import {toast} from "react-toastify";
import axios from "axios";
import {login, logout} from "../_reducers/Login";
import {
  deleteProductCategory,
  setProductCategory, setProductSubCategories,
} from "../_reducers/DataPanel/Products/productCategorySlice";
import {
  resetNewPriceList,
  resetNewProductMovements,
  resetSelectedProduct,
  setEditPriceList,
  setEditProductMovements,
  setPerPagePM,
  setPerPagePP,
  setPerPagePS,
  setPriceListProducts,
  setProductMovementsTemplates,
  setProductPriceListTemplates,
  setProducts,
  setProductSubmitting,
  setProductTemplates,
  setSearchProductMovements,
  setSearchProductPriceList,
  setSearchProducts,
  setSelectedEditProduct,
  setSelectedProductTemplate,
  setTotalItemsPM,
  setTotalItemsPP,
  setTotalItemsPS,
} from "../_reducers/DataPanel/Products/productsSlice";
import * as SETTINGS from '../_reducers/settingsSlice';
import {
  clearNewAdvancedType,
  clearNewBasicType,
  otherDataInitialValues,
  setAdvancedTypes,
  setAdvancedTypesBuys,
  setAdvancedTypesSales,
  setBasicTypes,
  setEditAdvancedType,
  setEditBasicType,
  setEmailSmtp,
  setPerPageATS,
  setPerPageBTS,
  setPrimerApiData,
  setPrimerMyDataData,
  setSearchAdvancedTypes,
  setSearchBasicTypes,
  setTotalItemsATS,
  setTotalItemsBTS
} from '../_reducers/settingsSlice';
import * as CLIENTS_DATA from '../_reducers/DataPanel/Clients/clientSlice';
import {
  resetNewClient,
  resetNewClientMovements,
  resetNewClientPayment,
  setClientMovementsTemplates,
  setClientPaymentsSearch,
  setClientPaymentsTemplates,
  setClients,
  setClientsPayment,
  setClientsSettings,
  setClientTemplates,
  setEditClient,
  setEditClientMovements,
  setEditClientPayment,
  setNewClientPayment,
  setperPageCMS,
  setperPageCPS,
  setperPageCS,
  setSearchClientMovements,
  setSearchClients,
  setTotalItemsCMS,
  setTotalItemsCPS,
  setTotalItemsCS,
  softResetNewClientPayment
} from '../_reducers/DataPanel/Clients/clientSlice';
import {getObjectFromArrayOfObjects} from '../_helpers/helperFunctions';
import {
  resetNewBankAccount, resetNewCard,
  resetNewCheque, resetNewLoan,
  resetNewPOS, setCardList, setCardSearchTotalItems, setCardsSearchData,
  setCashSettings, setChequeList, setChequeSearchData, setChequeSearchTotalItems,
  setEditBankAccount,
  setEditCashRegisters,
  setEditPOS, setLoansSearchData, setLoansSearchTotalItems,
  setSearchBankAccounts,
  setSearchCashRegisters,
  setSearchPOS
} from '../_reducers/DataPanel/Cash/cashSlice';
import {setSalesGeneralSettings, setSyncInvoicesProviderLog} from '../_reducers/DataPanel/Sales/salesSettingsSlice';
import {
  setCanBypassInvalidCompany,
  setEmronClientData,
  setEmronCompanyInvalid,
  setEmronCompanyInvalidDays,
  setIsEmron,
  setIsEmronClient,
  setPrimerMyDataExpirationModalMessage,
  setPrimerMyDataModalLink,
  setRefreshEditModalData,
  setSaveActiveVisit,
  setSaveAdvancedType,
  setSaveBasicType,
  setSaveBuys,
  setSaveClientPayments,
  setSaveEditAccountingRecord,
  setSaveEditBuys,
  setSaveEditClientInWholeSystem, setSaveEditFixedAssetMovement, setSaveEditFixedAssetRecord,
  setSaveEditProductMovements,
  setSaveEditWorkPermit,
  setSaveEmailSmtp,
  setSaveNewAccountingClosure, setSaveNewFixedAssetMovement, setSaveNewFixedAssetRecord,
  setSaveNewVisit,
  setSaveNewWorkPermit,
  setSavePrimerMyDataData,
  setSaveSales,
  setSendEmail,
  setSendEmployeeChangesToErgani,
  setSendEmployeeNewPasswordOnSave,
  setSendEmployeeQROnSave,
  setShowPrimerMyDataToExpireModal,
  setSaveQuotations, setSaveNewCheque, setSaveNewLoan, setSaveNewCard, setShowReleaseNotesModal
} from '../_reducers/activitySlice';
import {
  resetNewSales, setCorrelatedDclData, setCorrelatedVisitData,
  setEditSales,
  setNewSales,
  setPerPageSS,
  setPerPageQQ,
  setSalesTemplates,
  setQuotationsTemplates,
  setSearchQuotations,
  setSearchSales,
  setTotalItemsSS,
  setTotalItemsQQ,
  setNewQuotations,
  setEditQuotations,
  resetNewQuotations,
  setPrimerAiUrlTemplates, setNewPrimerAiUrl
} from '../_reducers/DataPanel/Sales/salesSlice';
import {checkPermission, getCurrentUser, getDocumentLabel, isEmpty, leadingZeros} from '../_helpers/commonFunctions';
import {
  setCompany,
  setCompanyDetails,
  setCompanyInstallations,
  setDashboardBuysData,
  setDashboardData,
  setUserSettings,
  updateDashboardData
} from '../_reducers/companySlice';
import {vatCategoryData} from '../_data/mydata/vatCategory';
import {highlightData} from "../_data/mydata/highlight";
import {measurementUnitsData} from "../_data/mydata/measurementUnits";
import {paymentTypesData} from "../_data/mydata/paymentTypes";
import {salesPurposeData} from "../_data/mydata/salesPurpose";
import {withHoldingTaxesData} from "../_data/mydata/withHoldingTaxes";
import {otherTaxesData} from "../_data/mydata/otherTaxes";
import {clientsCategoryData} from "../_data/clients/clients-settings";
import {feesData} from "../_data/mydata/fees";
import {taxStampCategoryData} from "../_data/mydata/taxStampCategory";
import {
  resetNewSupplier,
  resetNewSupplierPayment,
  setEditSupplier,
  setEditSupplierMovements,
  setEditSupplierPayment,
  setperPageSMSS,
  setperPageSPS,
  setperPageSSS,
  setSearchSupplierMovements,
  setSearchSuppliers,
  setSupplierPaymentsSearch,
  setSupplierPaymentsTemplates,
  setSuppliers,
  setSuppliersPayment,
  setSuppliersSettings,
  setTotalItemsSMSS,
  setTotalItemsSPS,
  setTotalItemsSSS,
  softResetNewSupplierPayment
} from "../_reducers/DataPanel/Suppliers/supplierSlice";
import {setBuysGeneralSettings} from "../_reducers/DataPanel/Buys/buysSettingsSlice";
import {
  resetNewBuys,
  setBuysTemplates,
  setEditBuys,
  setNewBuys,
  setPerPageBS,
  setSearchBuys,
  setTotalItemsBS
} from "../_reducers/DataPanel/Buys/buysSlice";
import jsPDF from "jspdf";
import {arial} from "../fonts/ARIAL-normal";
import {
  resetNewAccountingAccount,
  resetNewAccountingClosure,
  resetNewAccountingRecord,
  resetNewEmployee,
  setAccountingAdvancedTypes,
  setAccountingClosureTemplates,
  setAccountingPaymentTypes,
  setAccountingRecordCategories,
  setAccountingRecordSubcategories,
  setAccountingSettings, setBankAgreementAttention, setBankingCategories, setBankingSubCategories,
  setEditAccountingAccount,
  setEditAccountingRecord,
  setEditEmployee, setForceRefreshAccounts,
  setperPageAAS,
  setperPageAR,
  setperPageES,
  setSearchAccountingAccounts,
  setSearchAccountingRecords,
  setSearchEmployees, setShowNewBankAgreementAttentionModal, setShowNewBankAgreementAttentionModalMessage,
  setTaxisCredentials,
  setTotalItemsAAS,
  setTotalItemsAR,
  setTotalItemsES,
  softResetAccountingRecord,
  setSubmittedVatDeclarations,
  setTotalItemsSVD,
  setPerPageSVD, setSubmittedF4Declarations, setTotalItemsSF4, setPerPageSF4, setSubmittedF5Declarations,
  setTotalItemsSF5, setPerPageSF5, setUnregulatedDebts, setDebtsSummaryData, setTotalItemsSUD, setPerPageSUD,
  setAccountingCompanyCredentials
} from "../_reducers/DataPanel/Accounting/accountingSlice";
import {suppliersCategoryData} from "../_data/suppliers/suppliers-settings";
import {setSubscriptions} from "../_reducers/subscriptionsSlice";
import {autoUpdateTab, removeTab} from "../_reducers/TabsSlice";
import {addToForceRefresh} from "../_reducers/SearchTableSlice";
import {
    resetNewWorkMovement,
    resetNewWorkPermit,
    setCompanyHasErgani, setErganiInstallations,
    setPayrollSettings,
    setSearchWorkMovements,
    setSearchWorkMovementsPerPage,
    setSearchWorkMovementsTotalItems,
    setSearchWorkPermits,
    setSearchWorkPermitsPerPage,
    setSearchWorkPermitsTotalItems,
    setUpgradeEmployeeLimitModalData
} from "../_reducers/DataPanel/Payroll/payrollSlice";
import {
  resetActiveVisit,
  resetNewVisit,
  setActiveVisit, setActiveVisitClientData,
  setActiveVisitFirstLoad,
  setCompanyHasPrescription,
  setNewVisitOverrideModal, setSearchDrugs, setSearchDrugsPerPage,
  setSearchDrugsTotalItems, setSearchExams, setSearchExamsPerPage, setSearchExamsTotalItems,
  setSearchICD10s,
  setSearchICD10sPerPage,
  setSearchICD10sTotalItems,
  setSearchPrescriptions,
  setSearchPrescriptionsPerPage,
  setSearchPrescriptionsTotalItems,
  setSearchReferrals,
  setSearchReferralsPerPage,
  setSearchReferralsTotalItems,
  setSearchVisits,
  setSearchVisitsPerPage,
  setSearchVisitsTotalItems
} from "../_reducers/DataPanel/Prescription/prescriptionSlice";
import {
  newDclInitialValue,
  setActiveDcl,
  setDclRequestData, setEditDcl,
  setForceRefreshDclActive,
  setMainActiveDclLoader,
  setNewDcl, setRefreshEditDcl, setRefreshSelectedDcl,
  setSearchDcl,
  setSearchDclPerPage,
  setSearchDclTotalItems,
  setSelectedDcl,
  setShowDclAfterSaleNew, setShowDclPageAfterSaleNew, setShowSelectedDclModal
} from "../_reducers/DataPanel/Dcl/dclSlice";
import {
    resetNewFixedAsset, resetNewFixedAssetMovement, resetNewFixedAssetRecord, setEditFixedAsset,
    setEditFixedAssetMovement, setEditFixedAssetRecord,
    setFixedAssetsSettings, setSearchFixedAssetMovements,
    setSearchFixedAssetMovementsPerPage, setSearchFixedAssetMovementsTotalItems, setSearchFixedAssetRecords,
    setSearchFixedAssetRecordsPerPage, setSearchFixedAssetRecordsTotalItems,
    setSearchFixedAssets, setSearchFixedAssetsPerPage, setSearchFixedAssetsTotalItems
} from "../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import {selfUpdateBuy, selfUpdateSale} from "../_helpers/tabUpdater";
import {openEditVisit, openNewSale, openNewVisit, openTabByType} from "../_helpers/tabOpeners";
import {setAISettings} from "../_reducers/aiSlice";

const apiURL2 = process.env.REACT_APP_API_URL2;
const apiLoginURL = process.env.REACT_APP_LOGIN_URL;

export const userSigninWithUrl = (payloadObj, dispatch, selectedData, params, companyData, deviceId) => {
  axios.post(apiURL2 + `/public/detail`, params, {
    headers: { 'Content-Type': 'application/json' },
  }).then((res) => {
    if (res.status === 200) {
      if (res.data.status === 200 || res.data.status === "200") {
        let userPermissions = res.data.data.permissions
        localStorage.setItem("token", res.data.data.token);
        localStorage.setItem("deviceId", deviceId);
        localStorage.setItem("user", JSON.stringify(res.data.data));
        if (userPermissions.length > 0) {
          localStorage.setItem("permissions", JSON.stringify(userPermissions));
        }
        dispatch(setCompany(selectedData));
        dispatch(login());
        toast.success("You are successfully logged in.");
        dispatch(fetchPrimerMyDataCredentials(selectedData.id));
        window.history.pushState({}, "", window.location.origin); // Do not touch. Removes huge url and fixes change company
      } else {
        localStorage.clear();
        window.location.replace(`${apiLoginURL}?redirect=ERP&error=${res.data.message}`);
      }
    } else {
      if (res.error) {
        localStorage.clear();
        window.location.replace(`${apiLoginURL}?redirect=ERP&error=${res.error}`);
      }
    }
  }).catch((error) => {
    console.log(error.response)
    localStorage.clear();
    window.location.replace(`${apiLoginURL}?redirect=ERP&error=${error?.response?.data?.message}`);
  })
}

export const handleLogOut = () => {
  return (dispatch) => {
    const email = getCurrentUser()?.email;
    axios.post(apiURL2 + `/user/logout`, {email: email}, {
      headers: { 'Content-Type': 'application/json' },
    }).then((res) => {
      if (res.data.status === 200) {
        localStorage.clear();
        dispatch(logout());
        window.location.replace(`${apiLoginURL}?redirect=ERP&message=${res.data.message}`);
      } else {
        toast.error(res.data.message)
        localStorage.clear();
        dispatch(logout());
        window.location.replace(`${apiLoginURL}?redirect=ERP&error=${res.data.message}`);
      }
    }).catch((err) => {
      if (err) {
        let message = 'Service is unavailable for the moment. Please try again later.'
        localStorage.clear();
        dispatch(logout());
        window.location.replace(`${apiLoginURL}?redirect=ERP&error=${message}`);
      }
    })
  }
}

/*
 * Fetch Category
 */
export const fetchCategory = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/category-list`, { company: data.company, isActive: data.isActive }, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setProductCategory(res.data.data));
        dispatch(setProductSubCategories(res.data.subCategories));
      }
    }).catch(() => {
      console.log("Unable to load category.");
    })
  }
}

/*
 * Add New Category
 */
export const addNewCategory = (data, requestData) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/category-add`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message);
        dispatch(fetchCategory(requestData));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Add category Failed.");
      }
    })
  }
}

/*
 * Update Category Data
 */
export const putCategory = (data, id, action = "update", requestData) => {
  return (dispatch) => {
    axios.put(`${apiURL2}/category/category-update`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (action === "delete") {
          dispatch(deleteProductCategory({ id: id, data: res.data.data }));
          toast.success("Category deleted successfully.");
        } else {
          dispatch(fetchCategory(requestData));
          toast.success("Category updated successfully.");
        }
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "product-category", document: res.data.document}));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Category update failed.");
      }
    })
  }
}


export const addAccountingRecordCategory = (data, requestData) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/add-accounting-record-category`, JSON.stringify(data), {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message);
        dispatch(fetchAccountingRecordCategories(requestData.company));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
     console.log(error);
    })
  }
}

export const updateAccountingRecordCategory = (data, action = "update", requestData, setSubCategories, setSelectedCategory) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/update-accounting-record-category`, JSON.stringify(data), {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (action === "delete") {
          toast.success("1 Accounting Record Category deleted");
        } else {
          toast.success("Accounting Record Category updated.");
        }
        dispatch(fetchAccountingRecordCategories(requestData.company));
        if (typeof setSubCategories === 'function') {
          setSubCategories(res.data?.data?.subCategories);
        }
        if (typeof setSelectedCategory === 'function') {
          setSelectedCategory(res.data?.data);
        }
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

export const fetchAccountingRecordCategories = (company) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/accounting-record-categories-list`,{company: company}, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setAccountingRecordCategories(res.data.data));
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

export const fetchAccountingRecordSubcategories = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/accounting-record-subcategories-list`,{
        company: data
    }, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setAccountingRecordSubcategories(res.data.data));
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

export const fetchAccountingAdvancedTypes = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/accounting-advanced-types-list`,{
        company: data
    }, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setAccountingAdvancedTypes(res.data.data));
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

/*
 * Fetch Products
 */
export const fetchProducts = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/list-product`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setProducts(res.data.data));
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
    })
  }
}

export const fetchProductsONChange = (data, setData) => {
  return () => {
    axios.post(apiURL2 + `/category/list-product`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        setData(res.data.data);
      } else if (res.data && res.data.status === "422") {
        setData([]);
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
    })
  }
}

/*
 * Add New Product
 */
export const postProduct = (data, requestData, setLoader, reset = true, onSuccess) => {
  return (dispatch) => {
    if (data.mydata.length > 0) {
      setLoader(true);
      axios.post(apiURL2 + `/category/add-product`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((res) => {
          setLoader(false);
          if (res.data && res.data.status === "200") {
            toast.success(res.data.message);
            dispatch(fetchCategory(requestData));
            dispatch(setSelectedProductTemplate({}));
            dispatch(addToForceRefresh("Search Products"));
            if (reset) dispatch(resetSelectedProduct()); // Reset Selected Product
            if (onSuccess) onSuccess();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          setLoader(false);
          if (error && error.response) {
            toast.error(error.response.data?.errors);
          }
        });
    } else {
      toast.error("My Data table should have at least one row.");
    }
  }
}

/*
 * Update Product
 */
export const putProduct = (data, requestData, action = "update", reset = false, setLoadingSave, onSuccess) => {
  if (typeof setLoadingSave === 'function') setLoadingSave(true);
  if (data?.mydata?.length > 0) {
    return (dispatch) => {
      if (data._id) {
        data.id = data._id;
        delete data._id;
      }
      if (data.__v) {
        delete data.__v;
      }
      axios.put(apiURL2 + `/category/update-product`, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then((res) => {
          if (res.data && res.data.status === "200") {
            dispatch(fetchCategory(requestData));
            dispatch(setSelectedEditProduct(res.data.data));
            dispatch(addToForceRefresh("Search Products"));
            dispatch(autoUpdateTab(res.data.data));
            toast.success("Product updated.");
            if (onSuccess) onSuccess();
          } else if(res.data?.specialCode === "911") {
            dispatch(setRefreshEditModalData({show: true, documentType: "product", document: res.data.document}));
          } else {
            toast.error(res.data.errors);
          }
          if (typeof setLoadingSave === 'function') setLoadingSave(false);

        })
      .catch(error => {
        if (typeof setLoadingSave === 'function') setLoadingSave(false);
        console.log(error);
      })
    };
  } else {
    if (typeof setLoadingSave === 'function') setLoadingSave(false);
    toast.error("My Data table should have at least one row.");
  }
}

/*
 * Fetch Templates
 */
export const fetchTemplates = (data) => {
  const templateType = data && data.type ? data.type : "";
  return (dispatch) => {
    axios.post(apiURL2 + `/category/list-product-template`, data, {
      headers: {"Content-Type": "application/json"}
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (templateType === "product") {
          dispatch(setProductTemplates(res.data.data));
        } else if (templateType === "productMovements") {
          dispatch(setProductMovementsTemplates(res.data.data));
        } else if (templateType === "priceList") {
          dispatch(setProductPriceListTemplates(res.data.data));
        } else if (templateType === "client") {
          dispatch(setClientTemplates(res.data.data));
        } else if (templateType === "clientMovements") {
          dispatch(setClientMovementsTemplates(res.data.data));
        } else if (templateType === "sales") {
          dispatch(setSalesTemplates(res.data.data));
        } else if (templateType === "quotations" || templateType === "editQuotations") {
          dispatch(setQuotationsTemplates(res.data.data));
        } else if (templateType === "primerAiUrl") {
          dispatch(setPrimerAiUrlTemplates(res.data.data));
        } else if (templateType === "clientPayments") {
          dispatch(setClientPaymentsTemplates(res.data.data));
        } else if (templateType === "supplierPayments") {
          dispatch(setSupplierPaymentsTemplates(res.data.data));
        } else if (templateType === "buys") {
          dispatch(setBuysTemplates(res.data.data));
        } else if (templateType === "accountingClosure") {
          dispatch(setAccountingClosureTemplates(res.data.data));
        }
      } else {
        toast.error(res.data.errors);
      }
    }).catch((error) => {
      if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to load templates");
      }
    })
  }
}

/*
 * Add New Template
 */
export const postTemplate = (data, requestData, clearStates, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/add-product-template`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success("New template added.");
        clearStates();
        if (cb) cb();
        dispatch(fetchTemplates(requestData));
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to add template.");
      }
    })
  }
}

/*
 * Update Template
 */
export const putTemplate = (data, requestData, action = "update") => {
  return (dispatch) => {
    axios.put(apiURL2 + `/category/update-product-template`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (action === "delete") {
          toast.success("Template deleted.");
        } else {
          toast.success("Template data updated.");
        }
        dispatch(fetchTemplates(requestData));
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      toast.error(error + " Update Template");
    })
  }
}

/*
 * Add Price List
 */
export const postPriceList = (data, requestData, reset = true, setLoadingSave, setActivePriceListModal, onSuccess) => {
  setLoadingSave(true);
  return (dispatch) => {
    axios
      .post(apiURL2 + `/category/add-product-price`, data, {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        if (res.data && res.data.status === "200") {
          if (onSuccess) onSuccess();
          toast.success("New Price List Added.");
          dispatch(fetchPriceList(requestData));
          setActivePriceListModal(false);
          dispatch(addToForceRefresh("Search Product Price List"));
          if (reset) {
            dispatch(resetNewPriceList()); // reset
          }
        } else if(res.data && res.data?.status === "400"){
          setActivePriceListModal(true);
        } else {
          toast.error(res.data.error);
        }
        setLoadingSave(false);
      })
      .catch((error) => {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toast.error(error.response.data.errors);
        }
        setLoadingSave(false);
      });
  };
};

/*
 * Fetch Product Movements
 */
export const fetchPriceList = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/list-product-price`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setPriceListProducts(res.data.data));
      }
    }).catch((error) => {
      if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to fetch product price list.");
      }
    })
  }
}

/*
 * Update Product Price List
 */
export const putPriceList = (data, requestData, action = "update", setLoading, setActivePriceListModal, onSuccess) => {
  if (setLoading) setLoading(true);
  return (dispatch) => {
    if (data._id !== null) {
      data.id = data._id;
      axios.put(apiURL2 + `/category/update-product-price`, data, {
          headers: { "Content-Type": "application/json" },
        }).then((res) => {
          if (res.data && res.data.status === "200") {
            if (onSuccess) onSuccess();
            toast.success("Product Price List updated.");
            dispatch(setEditPriceList(res.data.data));
            dispatch(addToForceRefresh("Search Product Price List"));
            if (setActivePriceListModal) setActivePriceListModal(false);
          } else if(res.data?.specialCode === "911") {
            dispatch(setRefreshEditModalData({show: true, documentType: "price-list", document: res.data.document}));
          } else if (res.data && res.data.status === "400") {
            if (setActivePriceListModal) setActivePriceListModal(true);
          } else {
            toast.error(res.data.errors);
            console.log(res.data.errors);
          }
        if (setLoading) setLoading(false);
        }).catch((error) => {
          console.log(error + " Update Product Product Price List");
        if (setLoading) setLoading(false);
        });
    } else {
      console.log("null id error");
    }
  }
}

/*
 * Add Product Movement
 */
export const postProductMovements = (data, isEmronConnectFileERP, setLoading, onSuccess) => {
  return (dispatch) => {
    setLoading(true);
    data.number = data.number !== "" ? parseInt(data.number) : "";
    axios.post(apiURL2 + `/category/add-product-movements`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      setLoading(false);
      if (res.data && res.data.status === "200") {
        if (isEmronConnectFileERP) {
          localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
          return window.close();
        }
        toast.success("New Product Movements Added.");
        dispatch(resetNewProductMovements());
        dispatch(addToForceRefresh("Search Product Movements"));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      setLoading(false);
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to add product movements.");
      }
    })
  }
}

/*
 * Update Product Movements
 */
export const putProductMovements = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      if (setLoading) setLoading(true);
      data.id = data._id;
      delete data._id;
      axios.put(apiURL2 + `/category/update-product-movements`, data, {
        headers: { "Content-Type": "application/json" }
      }).then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          dispatch(setSaveEditProductMovements(false));
          dispatch(setEditProductMovements(res.data.data));
          dispatch(addToForceRefresh("Search Product Movements"));
          toast.success("Product Movement updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "product-movement", document: res.data.document}));
        } else {
          toast.error(res.data.error);
          console.log(res.data.error);
        }
        dispatch(setProductSubmitting(false));
      }).catch((error) => {
        if (setLoading) setLoading(false);
        console.log(error + " Update Product Product Movement");
      })
    } else {
      console.log("null id error");
    }
  }
}

/*
 * Add Setting Basic Type
 */
export const postBasicType = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    setLoading(true);
    axios.post(apiURL2 + `/settings/add-setting-basic-type`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      setLoading(false);
      if (res.data && res.data.status === "200") {
        toast.success("Basic Type Added.");
        dispatch(clearNewBasicType());
        dispatch(addToForceRefresh("Basic Type Search"));
        dispatch(setSaveBasicType(false));
        if (onSuccess) onSuccess();
      } else {
         toast.error(res.data.message);
      }
    }).catch((error) => {
      setLoading(false);
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to add basic type.");
      }
    })
  }
}

/*
 * Update Basic Type
 */
export const putBasicType = (data, requestData, setLoader, onSuccess) => {
  return (dispatch) => {
    if (setLoader) setLoader(true);
    if (data._id !== null) {
      data.id = data._id;
      axios.put(apiURL2 + `/settings/update-setting-basic-type`, data, { headers: { "Content-Type": "application/json" } })
        .then((res) => {
          if (res.data && res.data.status === "200") {
            dispatch(setEditBasicType(res.data.data));
            dispatch(addToForceRefresh("Basic Type Search"));
            toast.success("Basic Type Updated.");
            if (onSuccess) onSuccess();
          } else if(res.data?.specialCode === "911") {
            dispatch(setRefreshEditModalData({show: true, documentType: "basic-type", document: res.data.document}));
          } else {
            toast.error(res.data.error);
          }
          if (setLoader) setLoader(false);
        }).catch((error) => {
        console.log(error);
        if (setLoader) setLoader(false);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      });
    } else {
      if (setLoader) setLoader(false);
      console.log("null id error");
    }
  }
}

/*
 * Get Basic Types List
 */
export const fetchBasicTypes = (data) => {
  return (dispatch) => {
    data.isActive = "active";
    axios.post(apiURL2 + `/settings/list-setting-basic-type`, data, {
      headers: { 'Content-Type': 'application/json' }
    }).then(res => {
      if (res.data && res.data.status === '200') {
        dispatch(setBasicTypes(res.data.data));
      } else if (res.data && res.data.status === "422") {
        console.log("Basic types not found.");
      }
    }).catch((error) => {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to fetch basic types.");
      }
    })
  }
}

/*
 * Search Basic Types
 */
export const fetchBasicTypesSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/settings/basic-type-search-setting`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchBasicTypes(res.data.data.data));
        dispatch(setTotalItemsBTS(res.data.data.totalItems));
        dispatch(setPerPageBTS(res.data.data.perPage));
        if (res.data.data && res.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else if (res.data.status === "422") {
        toast.info("No records found.");
        dispatch(setSearchBasicTypes([]));
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Add Setting Advanced Type
 */
export const postAdvancedType = (data, setLoadingSave, onSuccess) => {
  return (dispatch) => {
    setLoadingSave(true);
    axios.post(apiURL2 + `/settings/add-setting-advance-type`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        toast.success("New Advanced Type Added.");
        dispatch(addToForceRefresh("Advanced Type Search"));
        dispatch(clearNewAdvancedType());
        dispatch(setSaveAdvancedType(false));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((err) => {
      setLoadingSave(false);
      console.log(err);
      toast.error("Σφάλμα κατά την αποθήκευση.");
    })
  }
}

/*
 * Update Advanced Type
 */
export const putAdvancedType = (data, setLoadingSave, onSuccess) => {
  return (dispatch) => {
    setLoadingSave(true);
    axios.put(apiURL2 + `/settings/update-setting-advance-type`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        dispatch(setEditAdvancedType(res.data.data));
        dispatch(addToForceRefresh("Advanced Type Search"));
        toast.success("Advanced Type Updated.");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "advanced-type", document: res.data.document}));
      } else {
        toast.error(res.data.error);
      }
    }).catch((err) => {
      setLoadingSave(false);
      console.log(err);
      toast.error("Σφάλμα κατά την αποθήκευση.");
    })
  }
}
/*
 * Get Advanced Types List
 */
export const fetchAdvancedTypes = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/settings/list-setting-advance-type`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setAdvancedTypes(res.data.data));
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

/*
 * Search Advanced Types
 */
export const fetchAdvancedTypesSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/settings/advance-type-search-setting`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchAdvancedTypes(res.data.data.data));
        dispatch(setTotalItemsATS(res.data.data.totalItems));
        dispatch(setPerPageATS(res.data.data.perPage));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        if (res.data && res.data.message) {
          toast.error(res.data.message);
        } else {
          toast.error(res.data.error);
        }
        dispatch(setSearchAdvancedTypes([])); // reset table
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Add Setting Advanced Type Sales
 */
export const postAdvancedTypeSales = (data, setLoadingSave, onSuccess) => {
  return (dispatch) => {
    setLoadingSave(true);
    axios.post(apiURL2 + `/settings/add-setting-advance-type-sale`, data, {
      headers: {"Content-Type": "application/json"}
    }).then((res) => {
      setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        toast.success("New advanced type added.");
        dispatch(addToForceRefresh("Advanced Type Search"));
        dispatch(clearNewAdvancedType());
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((err) => {
      setLoadingSave(false);
      console.log(err);
      toast.error("Σφάλμα κατά την αποθήκευση.");
    })
  }
}

/*
 * Add Setting Advanced Type Buys
 */
export const postAdvancedTypeBuys = (data, setLoadingSave, onSuccess) => {
  return (dispatch) => {
    setLoadingSave(true);
    axios.post(apiURL2 + `/settings/add-setting-advance-type-buy`, data,
      { headers: { "Content-Type": "application/json" } }
    ).then((res) => {
      setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        toast.success("New advanced type added.");
        dispatch(addToForceRefresh("Advanced Type Search"));
        dispatch(clearNewAdvancedType());
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((err) => {
      setLoadingSave(false);
      console.log(err);
      toast.error("Σφάλμα κατά την αποθήκευση.");
    })
  }
}

/*
 * Get Advanced Types List Sales
 */
export const fetchAdvancedTypesSales = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/settings/list-setting-advance-type-sale`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setAdvancedTypesSales(res.data.data));
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

/*
 * Get Advanced Types List Buys
 */
export const fetchAdvancedTypesBuys = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/settings/list-setting-advance-type-buy`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setAdvancedTypesBuys(res.data.data));
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

/*
 * Update Advanced Type
 */
export const putAdvancedTypeSales = (data, setLoadingSave, onSuccess) => {
  return (dispatch) => {
      setLoadingSave(true);
      axios.put(apiURL2 + `/settings/update-setting-advance-type-sale`, data,
          { headers: { "Content-Type": "application/json" } }
      ).then((res) => {
        setLoadingSave(false);
        if (res.data && res.data.status === "200") {
          dispatch(setEditAdvancedType(res.data.data));
          dispatch(addToForceRefresh("Advanced Type Search"));
          toast.success("Advanced Type Updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "advanced-type-sale", document: res.data.document}));
        } else {
          toast.error(res.data.message);
        }
      }).catch((err) => {
        setLoadingSave(false);
        console.log(err);
        toast.error("Σφάλμα κατά την αποθήκευση.");
      })
  }
}

/*
 * Update Advanced Type
 */
export const putAdvancedTypeBuys = (data, setLoadingSave, onSuccess) => {
  return (dispatch) => {
    setLoadingSave(true);
    axios.put(apiURL2 + `/settings/update-setting-advance-type-buy`, data,
        { headers: { "Content-Type": "application/json" } }
    ).then((res) => {
      setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        dispatch(setEditAdvancedType(res.data.data));
        dispatch(addToForceRefresh("Advanced Type Search"));
        toast.success("Advanced Type Updated.");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "advanced-type-buy", document: res.data.document}));
      } else {
        toast.error(res.data.message);
      }
    }).catch((err) => {
      setLoadingSave(false);
      console.log(err);
      toast.error("Σφάλμα κατά την αποθήκευση.");
    })
  }
}

/*
 * Get Client Settings
 */
export const fetchClientsSettings = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/client/list-client-setting`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data.length > 0) {
          dispatch(setClientsSettings(res.data.data[res.data.data.length - 1]));
        }
      } else if (res.data && res.data.status === "422") {
        let newSettings = CLIENTS_DATA.clientSettingsInitialValues;
        newSettings = { ...newSettings, categories: clientsCategoryData }; // Static Data Loading
        dispatch(postClientsSettings(newSettings, {company: data.company, year: data.year})); // Post Client Settings To API
      }
    }).catch((error) => {
        toast.error("Something went wrong!");
        console.log(error);
    })
  }
}


export const fetchAccountingSettings = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/list-accounting-setting`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data) {
          dispatch(setAccountingSettings(res.data.data.categories));
          dispatch(setTaxisCredentials(res.data.data.accountingTaxisnetCredentials));
          if (res.data.data.accountingCompanyCredentials) {
            dispatch(setAccountingCompanyCredentials(res.data.data.accountingCompanyCredentials));
          }
        }
        if (res.data.bankingCategories) dispatch(setBankingCategories(res.data.bankingCategories));
        if (res.data.bankingSubCategories) dispatch(setBankingSubCategories(res.data.bankingSubCategories));

        if (res.data.bankAgreementAttention === true) {
          dispatch(setBankAgreementAttention(true));
          dispatch(setShowNewBankAgreementAttentionModal(true));
          dispatch(setShowNewBankAgreementAttentionModalMessage(res.data.bankAgreementAttentionMessage));
        }
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to fetch Accounting settings.");
      }
    })
  }
}

export const fetchBankingSettings = (companyId) => {
  return (dispatch) => {
    axios.get(`${apiURL2}/accounting/banking-categories`, {
      headers: {"Content-Type": "application/json"},
      params: {
        company: companyId,
      }
    }).then((res) => {
      if (res.data.bankingCategories) dispatch(setBankingCategories(res.data.bankingCategories));
      if (res.data.bankingSubCategories) dispatch(setBankingSubCategories(res.data.bankingSubCategories));
    }).catch((error) => {
      console.log(error);
    })
  }
}

export const postAccountingSettings = (data, requestData) => {
  data.company = requestData.company;
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/add-accounting-setting`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(fetchAccountingSettings(requestData));
        toast.success("Accounting Settings Updated");
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "accounting-settings", document: res.data.document}));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to add client setting.");
      }
    })
  }
}

/*
 * Get Supplier Settings
 */
export const fetchSuppliersSettings = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/supplier/list-supplier-setting`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data.length > 0) {
          dispatch(setSuppliersSettings(res.data.data[res.data.data.length - 1]));
        }
      } else if (res.data && res.data.status === "422") {
        let newSettings = CLIENTS_DATA.clientSettingsInitialValues;
        newSettings = { ...newSettings, categories: suppliersCategoryData }; // Static Data Loading
        dispatch(postSuppliersSettings(newSettings, {company: data.company, year: data.year})); // Post Client Settings To API
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

/*
 * Add Clients Settings
 */
export const postClientsSettings = (data, requestData, setLoadingSave, onSuccess) => {
  data.company = requestData.company;
  data.year = requestData.year;
  if (setLoadingSave) setLoadingSave(true);
  return (dispatch) => {
    axios.post(apiURL2 + `/client/add-client-setting`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoadingSave) setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        dispatch(fetchClientsSettings(requestData));
        toast.success("Clients Settings Updated");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "client-settings", document: res.data.document}));
      } else if(res.data && res.data.status === "400"){
        toast.error(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoadingSave) setLoadingSave(false);
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to add client setting.");
      }
    })
  }
}

/*
 * Add Suppliers Settings
 */
export const postSuppliersSettings = (data, requestData, setLoading, onSuccess) => {
  data.company = requestData.company;
  data.year = requestData.year;
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/supplier/add-supplier-setting`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data && res.data.status === "200") {
        dispatch(fetchSuppliersSettings(requestData));
        toast.success("Suppliers Settings Updated");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "supplier-settings", document: res.data.document}));
      } else if (res.data && res.data.status === "400"){
        toast.error(res.data.message);
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Get Clients
 */
export const fetchClients = (data, setData) => {
  return () => {
    axios.post(apiURL2 + `/client/list-client`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if(setData) setData(res.data.data);
      }
      if (res.data && res.data.status === "422") {
        setData([]);
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

/*
 * Get Clients
 */
export const fetchSuppliers = (data, setData) => {
  return () => {
    axios.post(apiURL2 + `/supplier/list-supplier`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if(setData) setData(res.data.data);
      }
      if (res.data && res.data.status === "422") {
        if(setData) setData([]);
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

export const fetchInitialClients = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/client/list-client`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setClients(res.data.data));
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

export const fetchInitialProducts = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/list-product`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setProducts(res.data.data));
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

export const fetchInitialSuppliers = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/supplier/list-supplier`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setSuppliers(res.data.data));
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

/*
 * Add Client
 */
export const postClient = (data, requestData, emronData = {}, clearForm = false, setLoading, onSuccess) => {
  return (dispatch) => {
    setLoading(true);
    axios.post(apiURL2 + `/client/add-client`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      setLoading(false);
      if (res.data && res.data.status === "200") {
        toast.success("New Client Added.");
        dispatch(fetchClientsSettings(requestData));
        if (clearForm) dispatch(resetNewClient()); // Reset client form
        dispatch(addToForceRefresh("Client Search"));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      setLoading(false);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      console.log(error);
    })
  }
}


/*
 * Add Client
 */
export const postSupplier = (data, requestData, emronData = {}, clearForm = false, setLoading, onSuccess) => {
  return (dispatch) => {
    setLoading(true);
    axios.post(apiURL2 + `/supplier/add-supplier`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      setLoading(false);
      if (res.data && res.data.status === "200") {
        toast.success("New Supplier Added.");
        dispatch(fetchSuppliersSettings(requestData));
        if (clearForm) dispatch(resetNewSupplier()); // Reset supplier form
        dispatch(addToForceRefresh("Supplier Search"));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      setLoading(false);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      console.log(error);
    })
  }
}


/*
 * Update Client
 */
export const putClient = (data, requestData, action = "update", requestData2 = {}, clearForm = false, setLoading, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      data.id = data._id;
      const currentUser = getCurrentUser();
      data = {...data, userId: currentUser._id }
      axios.put(apiURL2 + `/client/update-client`, data, {
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          toast.success("Client updated.");
          if (clearForm) { // Reset client form
              dispatch(resetNewClient());
              dispatch(setSaveEditClientInWholeSystem(false));
          }
          dispatch(addToForceRefresh("Client Search"));
          dispatch(addToForceRefresh("Client Contracts"));
          dispatch(setEditClient(res.data.data));
          dispatch(autoUpdateTab(res.data.data));
          if (onSuccess) onSuccess();
        } else if (res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "client", document: res.data.document}));
        } else {
          toast.error(res.data.message);
        }
      }).catch((error) => {
        if (setLoading) setLoading(false);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        console.log(error);
      })
    } else {
      console.log("Null _id error");
    }
  }
}


/*
 * Update Supplier
 */
export const putSupplier = (data, requestData, setLoading, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      if (setLoading) setLoading(true);
      data.id = data._id;
      axios.put(apiURL2 + `/supplier/update-supplier`, data, {
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          dispatch(fetchInitialSuppliers(requestData));
          dispatch(addToForceRefresh("Supplier Search"));
          dispatch(setEditSupplier(res.data.data));
          dispatch(autoUpdateTab(res.data.data));
          toast.success("Supplier updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "supplier", document: res.data.document}));
        } else {
          toast.error(res.data.error);
        }
      }).catch((error) => {
        if (setLoading) setLoading(false);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        console.log(error);
      })
    } else {
      console.log("Null _id error");
    }
  }
}

/*
 * Add Client Movement
 */
export const postClientMovements = (data, isEmronConnectFileERP, setLoading, onSuccess) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    data.type = "clientMovements";
    axios.post(apiURL2 + `/client/add-client-movement`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data && res.data.status === "200") {
        if (isEmronConnectFileERP) {
          localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
          return window.close();
        }
        if (onSuccess) onSuccess();
        toast.success("New Client Movements Added.");
        dispatch(addToForceRefresh("Client Movements Search"));
        dispatch(resetNewClientMovements());
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      console.log(error);
    })
  }
}
/*
 * Add Supplier Movement
 */
export const postSupplierMovements = (data, isEmronConnectFileERP, setLoading, onSuccess) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    data.type = "supplierMovements";
    axios.post(apiURL2 + `/supplier/add-supplier-movement`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (isEmronConnectFileERP) {
        localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
        return window.close();
      }
      if (res.data && res.data.status === "200") {
        toast.success("New Supplier Movements Added.");
        dispatch(addToForceRefresh("Supplier Movements Search"));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      console.log(error);
    })
  }
}
/*
 * Update Client Movements
 */
export const putClientMovements = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.put(apiURL2 + `/client/update-client-movement`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data && res.data.status === "200") {
        dispatch(addToForceRefresh("Client Movements Search"));
        dispatch(setEditClientMovements(res.data.data));
        toast.success("Client Movement updated.");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "client-movement", document: res.data.document}));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      console.log(error);
    })
  }
}

/*
 * Update Supplier Movements
 */
export const putSupplierMovements = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      if (setLoading) setLoading(true);
      axios.put(apiURL2 + `/supplier/update-supplier-movement`, data, {
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          dispatch(addToForceRefresh("Supplier Movements Search"));
          dispatch(setEditSupplierMovements(res.data.data));
          toast.success("Supplier Movement updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
            dispatch(setRefreshEditModalData({show: true, documentType: "supplier-movement", document: res.data.document}));
        } else {
          toast.error(res.data.error);
          console.log(res.data.error);
        }
      }).catch((error) => {
        if (setLoading) setLoading(false);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        console.log(error);
      })
    } else {
      console.log("Null _id error");
    }
  }
}

/*
 * Product Search Table API
 */
export const fetchProductSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/master-product-search`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setTotalItemsPS(res.data.totalItems));
        dispatch(setSearchProducts(res.data.data));
        dispatch(setPerPagePS(res.data.perPage));
        if (res.data.data && res.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*`
 * Product Movements Search Table API
 */
export const fetchProductMovementsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/master-product-movement-search`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setSearchProductMovements(res.data.data));
        dispatch(setTotalItemsPM(res.data.totalItems));
        dispatch(setPerPagePM(res.data.perPage));
        if (res.data.data && res.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Product Price List Search Table API
 */
export const fetchProductPriceListSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/category/master-product-price-search`, data,
      { headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchProductPriceList(res.data.data));
        dispatch(setTotalItemsPP(res.data.totalItems));
        dispatch(setPerPagePP(res.data.perPage));
        if (res.data.data && res.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      }
    }).catch((err) => {
      console.log(err);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Client Search Table API
 */
export const fetchClientSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/client/master-client-search`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchClients(res.data.data.data));
        dispatch(setperPageCS(res.data.data.perPage));
        dispatch(setTotalItemsCS(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchClients([]));
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}


/*
 * Supplier Search  Table API
 */
export const fetchSupplierSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/supplier/master-supplier-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchSuppliers(res.data.data.data));
        dispatch(setperPageSSS(res.data.data.perPage));
        dispatch(setTotalItemsSSS(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchSuppliers([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Client Search Table API
 */
export const fetchClientMovementsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/client/master-client-movement-search`, data, {
      headers: {"Content-Type": "application/json"}
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchClientMovements(res.data.data.data));
        dispatch(setperPageCMS(res.data.data.perPage));
        dispatch(setTotalItemsCMS(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchClientMovements([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}


/*
 * Supplier Search Table API
 */
export const fetchSupplierMovementsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/supplier/master-supplier-movement-search`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchSupplierMovements(res.data.data.data));
        dispatch(setTotalItemsSMSS(res.data.data.totalItems));
        dispatch(setperPageSMSS(res.data.data.perPage));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchSupplierMovements([]));
        toast.error("No records found.");
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}
/*
 * Add Cash Registers
 */
export const postCashRegisters = (data, requestData, setLoading, onSuccess) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/cash/add-cash-registers`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data && res.data.status === "200") {
        toast.success("New Cash Register Added.");
        dispatch(fetchCashRegisters(requestData));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      }
    })
  }
}

/*
 * Fetch Cash Registers
 */
export const fetchCashRegisters = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/list-cash-registers`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchCashRegisters(res.data.data));
        if (cb) cb();
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Update Cash Registers
 */

export const putCashRegisters = (data, requestData, setLoading, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      if (setLoading) setLoading(true);
      data.id = data._id;
      if ("_id" in data) {
        delete data._id;
      }
      if ("__v" in data) {
        delete data.__v;
      }
      if ("type" in data) {
        delete data.type;
      }
      axios.put(apiURL2 + `/cash/update-cash-registers`, data, {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          dispatch(setEditCashRegisters(res.data.data));
          dispatch(fetchCashRegisters(requestData));
          toast.success("Cash Register updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "cashRegister", document: res.data.document}));
        } else {
          toast.error(res.data.error);
        }
      }).catch((error) => {
        if (setLoading) setLoading(false);
        console.log(error);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      })
    } else {
      console.log("null id error");
    }
  }
}

/*
 * Add Bank Accounts
 */
export const postBankAccounts = (data, requestData, setLoading, onSuccess) => {
  return (dispatch) => {
    setLoading(true);
    axios.post(apiURL2 + `/cash/add-bank-accounts`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      setLoading(false);
      if (res.data && res.data.status === "200") {
        dispatch(resetNewBankAccount());
        toast.success("New Bank Account Added.");
        dispatch(fetchBankAccounts(requestData));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Fetch Bank Accounts
 */
export const fetchBankAccounts = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/list-bank-accounts`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setSearchBankAccounts(res.data.data));
        if (cb) cb();
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchBankAccountsOnChange = (data, setData) => {
  return () => {
    axios.post(apiURL2 + `/cash/list-bank-accounts/`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        setData(res.data.data);
      }
      if (res.data.status === "422") {
        setData([]);
      }
    }).catch((error) => {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      }
    })
  }
}

/*
 * Update Bank Accounts
 */
export const putBankAccounts = (data, requestData, setLoading, onSuccess) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    if (data._id !== null) {
      data.id = data._id;
      if ("_id" in data) {
        delete data._id;
      }
      if ("__v" in data) {
        delete data.__v;
      }
      if ("type" in data) {
        delete data.type;
      }
      axios.put(apiURL2 + `/cash/update-bank-accounts`, data, {
        headers: {"Content-Type": "application/json"},
      }).then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          dispatch(setEditBankAccount(res.data.data));
          dispatch(fetchBankAccounts(requestData));
          toast.success("Bank Account updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "bankAccount", document: res.data.document}));
        } else {
          toast.error(res.data.error);
        }
      }).catch((error) => {
        if (setLoading) setLoading(false);
        console.log(error);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      })
    } else {
      console.log("null id error");
    }
  }
}

/*
 * Add POS
 */
export const postPOS = (data, requestData, setLoadingSave, onSuccess) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/add-pos`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        toast.success("New POS added.");
        dispatch(fetchPOS(requestData));
        dispatch(resetNewPOS());
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      setLoadingSave(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Fetch POS
 */
export const fetchPOS = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/list-pos`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchPOS(res.data.data));
        if (res.data.cards) { // Also fetch cards
          dispatch(setCardList(res.data.cards.map((o) => ({...o, isCard: true}))));
        }
        if (cb) cb();
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

export const fetchPOSOnChange = (data, setData) => {
  return async () => {
    await axios.post(apiURL2 + `/cash/list-pos/`, JSON.stringify(data), {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        setData(res.data.data);
      }
      if (res.data.status === "422") {
        setData([]);
      }
    }).catch((error) => {
      console.log(error);
    })
  }
}

/*
 * Update POS
 */
export const putPOS = (data, requestData, setLoading, onSuccess) => {
  return (dispatch) => {
    axios.put(apiURL2 + `/cash/update-pos`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data && res.data.status === "200") {
        dispatch(setEditPOS(res.data.data));
        dispatch(fetchPOS(requestData));
        toast.success("POS updated.");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "pos", document: res.data.document}));
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      toast.error("Connection error.");
      console.log(error);
    })
  }
}

/*
 * Add Sales General Settings
 */
export const postSalesGeneralSettings = (data, requestData, onSuccess) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/sale/add-sales-general-email-setting`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success("Sales General Settings Added");
        dispatch(fetchSalesGeneralSettings(requestData));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}


/*
 * Add Buys General Settings
 */
export const postBuysGeneralSettings = (data, requestData, onSuccess) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/buy/add-buys-general-email-setting/`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success("Buys General Settings Added");
        dispatch(fetchBuysGeneralSettings(requestData));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.error);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Update Sales General Settings
 */
export const putSalesGeneralSettings = (data, requestData, setLoader, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      data.id = data._id;
      if ("_id" in data) delete data._id;
      if ("__v" in data) delete data.__v;
      axios.post(apiURL2 + `/sale/update-sales-general-email-setting/`, data, {
        headers: { "Content-Type": "application/json" }
      }).then((res) => {
        if (res.data && res.data.status === "200") {
          toast.success("Sales General Settings Updated");
          dispatch(fetchSalesGeneralSettings(requestData));
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "sales-settings", document: res.data.document}));
        } else {
          toast.error(res.data.error);
        }
        if (setLoader) setLoader(false);
      }).catch((error) => {
        console.log(error);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        if (setLoader) setLoader(false);
      })
    }
  }
}

/*
 * Update Buys General Settings
 */
export const putBuysGeneralSettings = (data, requestData, setLoader, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      data.id = data._id;
      if ("_id" in data) delete data._id;
      if ("__v" in data) delete data.__v;
      axios.post(apiURL2 + `/buy/update-buys-general-email-setting`, data, {
        headers: { "Content-Type": "application/json" }
      }).then((res) => {
        if (res.data && res.data.status === "200") {
          dispatch(fetchBuysGeneralSettings(requestData));
          toast.success("Buys General Settings Updated");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "buys-settings", document: res.data.document}));
        } else {
          toast.error(res.data?.message);
        }
        if (setLoader) setLoader(false);
      }).catch((error) => {
        console.log(error);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        if (setLoader) setLoader(false);
      })
    }
  }
}

/*
 * Fetch Sales General Settings
 */
export const fetchSalesGeneralSettings = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/sale/sales-general-email-setting-list`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data.length > 0) {
          dispatch(setSalesGeneralSettings(res.data.data[res.data.data.length - 1]));
        }
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
    })
  }
}

export const fetchSyncInvoicesProviderLog = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/company/fetch-sync-invoices-provider-log`, { company: data }, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setSyncInvoicesProviderLog(res.data.data));
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
    })
  }
}

export const fetchDashboardData = (companyId, companyYear, setLoader, graphSettings = null, showToast = false) => {
  if (typeof setLoader === 'function') setLoader(true);
  return (dispatch) => {
    axios.post(apiURL2 + `/company/fetch-dashboard-data`, {company: companyId, year: companyYear, graphSettings: graphSettings}, {
      headers: { "Content-Type": "application/json" }
    }).then(async (res) => {
      if (res.data && res.data.status === "200") {
        if(graphSettings) {
          dispatch(updateDashboardData({...res.data.data}));
        } else {
          dispatch(setDashboardData({...res.data.data}));
        }
      }
      if (typeof setLoader === 'function') {
        setLoader(false);
        if(showToast) toast.success("Επιτυχής Ενημέρωση!");
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        if(showToast) toast.error(error.response.data.errors);
      }
      if (typeof setLoader === 'function') setLoader(false);
    })
  }
}
export const fetchDashboardBuysData = (companyId, companyYear, setLoader, graphSettings = null) => {
  if (typeof setLoader === 'function') {
    setLoader(true);
  }
  return (dispatch) => {
    axios.post(apiURL2 + `/company/fetch-dashboard-buys-data`, {company: companyId, year: companyYear, graphSettings: graphSettings}, {
      headers: { "Content-Type": "application/json" }
    }).then(async (res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setDashboardBuysData({...res.data.data}));
      }
      if (typeof setLoader === 'function') {
        setLoader(false);
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      if (typeof setLoader === 'function') {
        setLoader(false);
      }
    })
  }
}
export const triggerSyncProviderInvoices = (data, setLoader, mass = false, year) => {
  setLoader(true);
  return (dispatch) => {
    axios.post(apiURL2 + `/company/sync-invoices-provider`, {company: data, mass: mass, year: year}, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message)
      } else {
        toast.error(res.data.message)
      }
      dispatch(fetchSyncInvoicesProviderLog(data));
      setLoader(false);
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      setLoader(false);
    })
  }
}

export const triggerCleanFailedSyncs = (data, setLoader) => {
  setLoader(true);
  return (dispatch) => {
    axios.post(apiURL2 + "/company/clear-failed-syncs/", {company: data}, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message)
      } else {
        toast.error(res.data.message)
      }
      dispatch(fetchSyncInvoicesProviderLog(data));
      setLoader(false);
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      setLoader(false);
    })
  }
}


/*
 * Fetch Buys General Settings
 */
export const fetchBuysGeneralSettings = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/buy/buys-general-email-setting-list/`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data.length > 0) {
          dispatch(setBuysGeneralSettings(res.data.data[res.data.data.length - 1]));
        }
      }
    }).catch((error) => {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      }
    })
  }
}

/*
 * Add Sales
 */
export const postSales = (data, company, handleDpActions = null, printOnSave = false, sendEmail, setLoader,
                          advancedTypesSales, isEmronConnectFileERP = false, showSelectedDcl = false, showEditDcl = false,
                          TABS_DATA, dataCallback = null) => {
  if (setLoader) setLoader(true);
  if (data?.newClient && data?.newClient !== "") {
    data.clientName = data.newClient;
  }
  let saveType = data?.isActive;
  return (dispatch) => {
    axios.post(apiURL2 + `/sale/add-sale/`, data, {
      headers: {"Content-Type": "application/json"},
    })
    .then(async (res) => {
      if (res.data && res.data.status === "200") {
        if (isEmronConnectFileERP) {
          localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
          return window.close();
        }
        toast.success("Το παραστατικό δημιουργήθηκε με επιτυχία!");
        if (res.data.data?.myDataError !== "" && res.data.data?.myDataError !== undefined) toast.error(res.data.data?.myDataError);
        if (res.data.data?.correlatedDclError) toast.error("Η Συσχέτιση Εγγραφής Ψηφιακού Πελατολογίου απέτυχε: " + res.data.data.correlatedDclError);
        await dispatch(fetchAdvancedTypesSales({ company: company }));
        await dispatch(setNewSales(res.data.data));
        // Used in Data Panel index to show print on save
        if (handleDpActions !== null && printOnSave === true) await handleDpActions("printOnSave");
        if (handleDpActions !== null && sendEmail === "active") await handleDpActions("sendEmailOnSave", res.data.data);
        dispatch(addToForceRefresh("Sales Search"));
        await dispatch(resetNewSales());
        await dispatch(setSaveSales(false)); // Set save status false
        if (showSelectedDcl || showEditDcl) {
          const returnTab = showSelectedDcl ? "new-dcl" : "edit-dcl";
          dispatch(removeTab("sales-new"));
          dispatch(openTabByType(returnTab, TABS_DATA));
          dispatch(setShowDclAfterSaleNew(false));
          dispatch(setShowDclPageAfterSaleNew(false));
          dispatch(setForceRefreshDclActive(true));
          dispatch(addToForceRefresh("Dcl Search"));
          if (returnTab === "edit-dcl") dispatch(setRefreshEditDcl(true));
          if (returnTab === "new-dcl") dispatch(setRefreshSelectedDcl(true));
        }
        // Set Data to new if save and repeat
        if (res.data.data && saveType === "draft") {
          let draftSale = JSON.parse(JSON.stringify(res.data.data));
          let date = new Date();
          const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
          // Passing updated time on template selection
          draftSale.date = date;
          draftSale.time = currentTime;
          draftSale.number = "";
          draftSale._id = undefined;
          draftSale.myDataStatus = "not_sent";
          draftSale.transmissionFailure = undefined;
          draftSale.mark = undefined;
          draftSale.uid = undefined;
          draftSale.authCode = undefined;
          draftSale.myDataRequest = undefined;
          draftSale.myDataEnvironment = undefined;
          draftSale.myDataError = undefined;
          draftSale.myDataDestination = undefined;
          draftSale.transactionDetails = undefined;
          draftSale.linkedClientPayments = undefined;
          let dtData = getObjectFromArrayOfObjects(advancedTypesSales, draftSale.documentType, '_id');
          let selectedDocumentTypeData = dtData['0'];
          let selectedInstallation = getObjectFromArrayOfObjects(selectedDocumentTypeData['documentNumbering'], draftSale.installation, "installationMasterId");
          let selectedInstallationNumbering = selectedInstallation.filter(selected => selected.preNumber === draftSale.preNumber);
          if (Object.keys(selectedInstallation).length > 0 && selectedInstallationNumbering.length > 0) {
            draftSale.number = selectedInstallationNumbering[0].number + 1;
          } else {
            draftSale.number = "";
          }
          await dispatch(resetNewSales());
          await dispatch(setNewSales(draftSale));
          await dispatch(setSaveSales(true));
        } else {
          await dispatch(resetNewSales());
          await dispatch(setSaveSales(false)); // Set save status false
        }
        await dispatch(setSendEmail("inactive"));
        if (dataCallback) dataCallback(res.data.data);
      } else {
        toast.error(res.data.message);
      }
      if (setLoader) setLoader(false);
    }).catch((error) => {
      console.log(error)
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      dispatch(resetNewSales());
      dispatch(setSaveSales(false)); // Set save status false
      if (setLoader) setLoader(false);
    });
  }
}

/*
 * Add Quotations
 */
export const postQuotations = (
    data, company, handleDpActions = null, printOnSave = false, sendEmail, setLoader,
    advancedTypesSales, TABS_DATA, dataCallback = null
) => {
  if (setLoader) setLoader(true);
  if (data?.newClient && data?.newClient !== "") {
    data.clientName = data.newClient;
  }
  let saveType = data?.isActive;
  return (dispatch) => {
    axios.post(apiURL2 + `/sale/add-quotation/`, data, {
      headers: {"Content-Type": "application/json"},
    })
        .then(async (res) => {
          if (res.data && res.data.status === "200") {
            toast.success("Η προσφορά δημιουργήθηκε με επιτυχία!");
            await dispatch(fetchAdvancedTypesSales({ company: company }));
            await dispatch(setNewQuotations(res.data.data));
            // Used in Data Panel index to show print on save
            if (handleDpActions !== null && printOnSave === true) await handleDpActions("printOnSave");
            if (handleDpActions !== null && sendEmail === "active") await handleDpActions("sendEmailOnSave", res.data.data);
            dispatch(addToForceRefresh("Quotations Search"));
            await dispatch(resetNewQuotations());
            await dispatch(setSaveQuotations(false)); // Set save status false
            // Set Data to new if save and repeat
            if (res.data.data && saveType === "draft") {
              let draftQuotation = JSON.parse(JSON.stringify(res.data.data));
              let date = new Date();
              const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
              // Passing updated time on template selection
              draftQuotation.date = date;
              draftQuotation.time = currentTime;
              draftQuotation.number = "";
              draftQuotation._id = undefined;
              draftQuotation.transmissionFailure = undefined;
              draftQuotation.mark = undefined;
              draftQuotation.uid = undefined;
              draftQuotation.authCode = undefined;
              draftQuotation.myDataRequest = undefined;
              draftQuotation.myDataEnvironment = undefined;
              draftQuotation.myDataError = undefined;
              draftQuotation.myDataDestination = undefined;
              let dtData = getObjectFromArrayOfObjects(advancedTypesSales, draftQuotation.documentType, '_id');
              let selectedDocumentTypeData = dtData['0'];
              let selectedInstallation = getObjectFromArrayOfObjects(selectedDocumentTypeData['documentNumbering'], draftQuotation.installation, "installationMasterId");
              let selectedInstallationNumbering = selectedInstallation.filter(selected => selected.preNumber === draftQuotation.preNumber);
              if (Object.keys(selectedInstallation).length > 0 && selectedInstallationNumbering.length > 0) {
                draftQuotation.number = selectedInstallationNumbering[0].number + 1;
              } else {
                draftQuotation.number = "";
              }
              await dispatch(setNewQuotations(draftQuotation));
              await dispatch(setSaveQuotations(true));
            } else {
              await dispatch(resetNewQuotations());
              await dispatch(setSaveQuotations(false)); // Set save status false
            }
            await dispatch(setSendEmail("inactive"));
            if (dataCallback) dataCallback(res.data.data);
          } else {
            toast.error(res.data.message);
          }
          if (setLoader) setLoader(false);
        }).catch((error) => {
      console.log(error)
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      dispatch(resetNewQuotations());
      dispatch(setSaveQuotations(false)); // Set save status false
      if (setLoader) setLoader(false);
    });
  }
}

/*
 * Add Buys
 */
export const postBuys = (data, requestData, handleDpActions = null, printOnSave = false, setLoader,
                         advancedTypesSales, sendEmail, isEmronConnectFileERP, dataCallback) => {
  if (setLoader) setLoader(true);
  if (data.newSupplier && data.newSupplier !== "") {
    data.supplierName = data.newSupplier;
  }
  let saveType = data.isActive;
  return (dispatch) => {
    axios
      .post(apiURL2 + `/buy/add-buy/`, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
      })
      .then(async (res) => {
        if (res.data && res.data.status === "200") {
          if (isEmronConnectFileERP) {
            localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
            return window.close();
          }
          toast.success("Η αγορά καταχωρήθηκε επιτυχώς.");
          if(res.data.data?.myDataError !== "" &&  res.data.data?.myDataError !== undefined){
            toast.error(res.data.data?.myDataError);
          }
          await dispatch(fetchAdvancedTypesBuys({ company: requestData.company }));
          dispatch(setNewBuys(res.data.data));
          // Used in Data Panel index to show print on save
          if (handleDpActions !== null && printOnSave === true) await handleDpActions("printOnSave");
          if (handleDpActions !== null && sendEmail === "active") await handleDpActions("sendEmailOnSave", res.data.data);

          dispatch(addToForceRefresh("Buys Search"));
          // Set Data to new if save and repeat
          if (res.data.data && saveType === "draft") {
            let draftBuy = JSON.parse(JSON.stringify(res.data.data));
            let date = new Date();
            const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
            // Passing updated time on template selection
            draftBuy.date = date;
            draftBuy.time = currentTime;
            draftBuy.number = "";
            draftBuy._id = undefined;
            draftBuy.myDataStatus = "not_sent";
            draftBuy.transmissionFailure = undefined;
            draftBuy.mark = undefined;
            draftBuy.uid = undefined;
            draftBuy.authCode = undefined;
            draftBuy.myDataRequest = undefined;
            draftBuy.myDataEnvironment = undefined;
            draftBuy.myDataError = undefined;
            let dtData = getObjectFromArrayOfObjects(advancedTypesSales, draftBuy.documentType, '_id');
            let selectedDocumentTypeData = dtData['0'];
            let selectedInstallation = getObjectFromArrayOfObjects(selectedDocumentTypeData['documentNumbering'], draftBuy.installation, "installationMasterId");
            let selectedInstallationNumbering = selectedInstallation.filter(selected => selected.preNumber === draftBuy.preNumber);
            if (Object.keys(selectedInstallation).length > 0 && selectedInstallationNumbering.length > 0) {
              draftBuy.number = selectedInstallationNumbering[0].number + 1;
            } else {
              draftBuy.number = "";
            }
            dispatch(resetNewBuys());
            dispatch(setNewBuys(draftBuy));
          } else {
              dispatch(resetNewBuys());
              dispatch(setSaveBuys(false)); // Set save status false
          }
          if (dataCallback) dataCallback(res.data.data);
        } else {
          toast.error(res.data.error || res.data.message);
        }
        if (setLoader) setLoader(false);
      })
      .catch((error) => {
        console.log(error)
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toast.error(error.response.data.errors);
        }
        if (setLoader) setLoader(false);
      })
  }
}

/*
 * Update Sales
 */
export const putSales = (data, setLoading, onSuccess) => {
  let saveType = data.isActive;
  return (dispatch) => {
    if (data._id !== null) {
      setLoading(true);
      data.id = data._id;
      axios.put(apiURL2 + `/sale/update-sale`, data, {
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        setLoading(false);
        if (res.data && res.data.status === "200") {
          toast.success("Sales Updated.");
          if (res.data.data && saveType === "draft") {
            dispatch(setNewSales(res.data.data));
          }
          if (onSuccess) onSuccess();
        } else {
          toast.error(res.data.error);
        }
      }).catch((error) => {
        setLoading(false);
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toast.error(error.response.data.errors);
        }
      })
    }
  }
}

/*
 * Update Quotations
 */
export const putQuotations = (data, setLoading, onSuccess) => {
  let saveType = data.isActive;
  return (dispatch) => {
    if (data._id !== null) {
      setLoading(true);
      data.id = data._id;
      axios.put(apiURL2 + `/sale/update-quotation`, data, {
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        setLoading(false);
        if (res.data && res.data.status === "200") {
          toast.success("Quotations Updated.");
          dispatch(setEditQuotations(res.data.data));
          dispatch(addToForceRefresh("Quotations Search"));
          if (res.data.data && saveType === "draft") {
            dispatch(setNewQuotations(res.data.data));
          }
          if (onSuccess) onSuccess();
        } else {
          toast.error(res.data.error);
        }
      }).catch((error) => {
        setLoading(false);
        if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors
        ) {
          toast.error(error.response.data.errors);
        }
      })
    }
  }
}

/*
 * Update Buys
 */
export const putBuys = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      if (setLoading) setLoading(true);
      data.id = data._id;
      axios.put(apiURL2 + `/buy/update-buy`, data, {
        headers: { "Content-Type": "application/json" },
      }).then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          dispatch(addToForceRefresh("Buys Search"));
          dispatch(setEditBuys(res.data.data));
          toast.success("Buy updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "buy", document: res.data.document}));
        } else {
          toast.error(res.data.message);
        }
      }).catch((error) => {
        if (setLoading) setLoading(false);
        if (error && error.response && error.response.data && error.response.data.errors) {
          toast.error(error.response.data.errors);
        }
      })
    }
  }
}

/*
 * Get Client Payment
 */
export const fetchClientPaymentData = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/client/list-client-payment`, data, {
      headers: {"Content-Type": "application/json"}
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setClientsPayment(res.data.data));
      }
    }).catch((error) => {
      if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to fetch client settings.");
      }
    })
  }
}

/*
 * Get Supplier Payment
 */
export const fetchSupplierPaymentData = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/supplier/list-supplier-payment`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setSuppliersPayment(res.data.data));
      }
    }).catch((error) => {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to fetch supplier settings.");
      }
    })
  }
}

/*
 * Add Client Payment
 */
export const postClientPayment = (data, requestData, setLoader, handleDpActions = null, printOnSave = false,
                                  saveAndRepeat = false, sendEmail, setShowPOSModal, setShowPOSModalCancel, isEmronConnectFileERP, dataCallback = null) => {
  let logRequestData = {
    company: requestData.company,
    year: requestData.year,
  }
  setLoader(true);
  return (dispatch) => {
    data.posAmount = data?.posDetails["0"]?.amount ? data.posDetails["0"].amount : 0;
    data.bankAmount = data?.bankDetails["0"]?.amount ? data.bankDetails["0"].amount : 0;
    data.chequeAmount = data?.chequeDetails["0"]?.amount ? data.chequeDetails["0"].amount : 0;
    if (data.chequeDetails && isEmpty(data.chequeDetails[0]?._id)) data.chequeDetails = [];

    axios.post(apiURL2 + `/client/add-client-payment`, data, {
      headers: { "Content-Type": "application/json" },
    }).then(async (res) => {
      if (setShowPOSModal && typeof setShowPOSModal === "function") setShowPOSModal(false);
      if (setShowPOSModalCancel && typeof setShowPOSModalCancel === "function" && data.myDataType === "8.5") setShowPOSModalCancel(false);
      if (res.data && res.data.status === "200") {
        if (isEmronConnectFileERP) {
          localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
          return window.close();
        }
        toast.success("New Client Payment Added.");
        await dispatch(setNewClientPayment(res.data.data));
        // Used in Data Panel index to show print on save
        if (handleDpActions !== null && printOnSave === true) {
          await handleDpActions("printOnSave");
        }
        if (handleDpActions !== null && sendEmail === "active") {
          await handleDpActions("sendEmailOnSave", res.data.data);
        }
        if (saveAndRepeat) {
          let newPayment = structuredClone(data);
          let date = new Date();
          const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
          newPayment.date = date;
          newPayment.time = currentTime;
          newPayment.number = String(Number(data.number) + 1);
          newPayment.paymentType = "";
          newPayment.paymentTypeName = "";
          newPayment.paymentTypeType = "";
          newPayment.paymentNotes = "";
          newPayment.amount = "0";
          newPayment.reason = "";
          dispatch(softResetNewClientPayment(newPayment));
        } else {
          dispatch(resetNewClientPayment());
        }
        dispatch(addToForceRefresh("Client Payments Search"));
        dispatch(fetchAdvancedTypes(logRequestData));
        if (dataCallback) dataCallback(res.data.data);
      } else {
        toast.error(res.data.message);
        dispatch(setSaveClientPayments(true));
      }
      setLoader(false);
    }).catch((error) => {
      console.log(error);
      if (setShowPOSModal && typeof setShowPOSModal === "function") setShowPOSModal(false);
      if (setShowPOSModalCancel && typeof setShowPOSModalCancel === "function" && data.myDataType === "8.5") setShowPOSModalCancel(false);
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Σφάλμα κατά την αποστολή αιτήματος.");
      }
      setLoader(false);
    })
  }
}

/*
 * Add Supplier Payment
 */
export const postSupplierPayment = (data, requestData, setLoadingSave, saveAndRepeat = false, isEmronConnectFileERP, dataCallback = null) => {
  let logRequestData = {
    company: requestData.company,
    year: requestData.year,
  }
  if (setLoadingSave) setLoadingSave(true);
  return (dispatch) => {
    data.posAmount = data.posDetails["0"].amount;
    data.bankAmount = data.bankDetails["0"].amount;
    data.chequeAmount = data.chequeDetails["0"].amount;
    axios.post(apiURL2 + `/supplier/add-supplier-payment`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      setLoadingSave(false);
      if (res.data && res.data.status === "200") {
        if (isEmronConnectFileERP) {
          localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
          return window.close();
        }
        toast.success("New Supplier Payment Added.");
        if (saveAndRepeat) {
          let newPayment = data;
          let date = new Date();
          const currentTime = leadingZeros(date.getHours(), 2) + ":" + leadingZeros(date.getMinutes(), 2);
          newPayment.date = date;
          newPayment.time = currentTime;
          newPayment.number = String(Number(data.number) + 1);
          newPayment.paymentType = "";
          newPayment.paymentTypeName = "";
          newPayment.paymentTypeType = "";
          newPayment.paymentNotes = "";
          newPayment.amount = "0";
          newPayment.reason = "";
          dispatch(softResetNewSupplierPayment(newPayment));
        } else {
          dispatch(resetNewSupplierPayment());
        }
        dispatch(addToForceRefresh("Supplier Payments Search"));
        dispatch(fetchAdvancedTypes(logRequestData));
        if (dataCallback) dataCallback(res.data.data);
      } else {
        toast.error(res.data?.message);
      }
    }).catch((error) => {
      setLoadingSave(false);
      if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errors
      ) {
        toast.error(error.response.data.errors);
      } else {
        console.log("Unable to add supplier payment.");
      }
    })
  }
}


/*
 * Update Client Payment
 */
export const putClientPayment = (data, setLoader, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      data.id = data._id;
      data.posAmount = data?.posDetails["0"]?.amount ? data.posDetails["0"].amount : 0;
      data.bankAmount = data?.bankDetails["0"]?.amount ? data.bankDetails["0"].amount : 0;
      data.chequeAmount = data?.chequeDetails["0"]?.amount ? data.chequeDetails["0"].amount : 0;
      if (data.chequeDetails && isEmpty(data.chequeDetails[0]?._id)) data.chequeDetails = [];

      axios.put(apiURL2 + `/client/update-client-payment`, data, {
          headers: { "Content-Type": "application/json" },
        }).then((res) => {
          if (res.data && res.data.status === "200") {
            toast.success("Client Payment updated.");
            dispatch(addToForceRefresh("Client Payments Search"));
            dispatch(setEditClientPayment(res.data.data));
            if (onSuccess) onSuccess();
          } else if(res.data?.specialCode === "911") {
            dispatch(setRefreshEditModalData({show: true, documentType: "client-payment", document: res.data.document}));
          } else {
            toast.error(res.data.message);
          }
          if (setLoader) setLoader(false);
        }).catch((error) => {
          if (setLoader) setLoader(false);
          toast.error(error + " Update Client Payment");
        });
    } else {
      console.log("Null id error. Please refresh and try again.");
    }
  }
}

/*
 * Update Supplier Payment
 */
export const putSupplierPayment = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (data._id !== null) {
      data.id = data._id;
      data.posAmount = data?.posDetails["0"]?.amount ? data.posDetails["0"].amount : 0;
      data.bankAmount = data?.bankDetails["0"]?.amount ? data.bankDetails["0"].amount : 0;
      data.chequeAmount = data?.chequeDetails["0"]?.amount ? data.chequeDetails["0"].amount : 0;
      axios.put(apiURL2 + `/supplier/update-supplier-payment`, data, {
        headers: {"Content-Type": "application/json"},
      }).then((res) => {
        if (setLoading) setLoading(false);
        if (res.data && res.data.status === "200") {
          dispatch(addToForceRefresh("Supplier Payments Search"));
          dispatch(setEditSupplierPayment(res.data.data));
          toast.success("Supplier Payment updated.");
          if (onSuccess) onSuccess();
        } else if(res.data?.specialCode === "911") {
          dispatch(setRefreshEditModalData({show: true, documentType: "supplier-payment", document: res.data.document}));
        } else {
          toast.error(res.data?.message);
        }
      }).catch((error) => {
        console.log(error);
        if (setLoading) setLoading(false);
        toast.error(error + " Update Supplier Payment");
      })
    } else {
      console.log("Null id error. Please refresh and try again.");
    }
  }
}

export const sendFilteredToMyDataApi = (data, setSendFilteredToMyDataResponse, showSendFilteredToMyDataResponse, setLoader, type) => {
  /*
    type: sale || buy || accounting
   */
  return () => {
    setLoader(true);
    axios.post(apiURL2 + `/${type}/mass-send-to-mydata`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        let responseStringModal = "";
        if(res.data.data.length > 0) {
          res.data.data.map(obj => {
            if(obj?.uid !== undefined) {
              responseStringModal += obj?.name + " Mark: " + obj?.mark + " Uid: " + obj?.uid + " MyDataStatus: " + obj?.myDataStatus + "\n\n";
            } else if(obj?.message !== undefined){
              responseStringModal += obj?.name + " Error: " + obj?.message + " \n\n";
            } else {
              responseStringModal += obj?.name  + " MyDataStatus: " + obj?.myDataStatus + " Error: " + obj?.myDataError + " \n\n";
            }
            return obj;
          })
        } else {
          responseStringModal = "No data found with these filters.";
        }
        setSendFilteredToMyDataResponse(responseStringModal);
        showSendFilteredToMyDataResponse(true);
        setLoader(false);
      } else {
        setSendFilteredToMyDataResponse(res.data.message);
        showSendFilteredToMyDataResponse(true);
        setLoader(false);
      }
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        console.log(error.response.data.errors);
        toast.error(error.response.data.errors);
        setLoader(false);
      }
    })
  }
}

/*
 * Search Sales
 */
export const fetchSalesSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/sale/sales-search-data`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setSearchSales(res.data.data.data));
        if (res.data.data.totalItems && res.data.data.perPage) {
          dispatch(setTotalItemsSS(res.data.data.totalItems));
          dispatch(setPerPageSS(res.data.data.perPage));
        }
        if (res.data.data && res.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        if (res.data && res.data.message) {
          toast.error(res.data && res.data.message);
        }
        if (res.data && res.data.error) {
          toast.error(res.data && res.data.error);
        }
        dispatch(setSearchSales([])); // reset table
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
* Search Quotations
 */
export const fetchQuotationsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/sale/quotations-search-data`, data, {
      headers: {"Content-Type": "application/json"}
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setSearchQuotations(res.data.data.data));
        if (res.data.data.totalItems && res.data.data.perPage) {
          dispatch(setTotalItemsQQ(res.data.data.totalItems));
          dispatch(setPerPageQQ(res.data.data.perPage));
        }
        if (res.data.data && res.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        if (res.data && res.data.message) {
          toast.error(res.data && res.data.message);
        }
        if (res.data && res.data.error) {
          toast.error(res.data && res.data.error);
        }
        dispatch(setSearchQuotations([])); // reset table
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Search Buys
 */
export const fetchBuysSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/buy/buys-search-data`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if(res.data.data.data.length > 0) {
          for (let item of res.data.data.data) {
            item.preNumberAndNumber = String(item.preNumber || "").replace("noprefix", "") + " " + String(item.number);
          }
        }
        dispatch(setSearchBuys(res.data.data.data));
        if (res.data.data && res.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
        if (res.data.data.totalItems && res.data.data.perPage) {
          dispatch(setTotalItemsBS(res.data.data.totalItems));
          dispatch(setPerPageBS(res.data.data.perPage));
        }
      } else {
        if (res.data && res.data.message) {
          toast.error(res.data && res.data.message);
        }
        if (res.data && res.data.error) {
          toast.error(res.data && res.data.error);
        }
        dispatch(setSearchBuys([])); // reset table
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

/*
 * Search Client Payments
 */
export const fetchClientPaymentsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/client/client-payment-search`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data.data && res.data.data.data.length > 0) {
          for (let cp of res.data.data.data) {
            cp.preNumberAndNumber = cp.preNumber.replace("noprefix", "") + " " + cp.number;
          }
        }
        dispatch(setClientPaymentsSearch(res.data.data.data));
        dispatch(setTotalItemsCPS(res.data.data.totalItems));
        dispatch(setperPageCPS(res.data.data.perPage));
        if (res.data.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        if (res.data && res.data.message) {
          toast.error(res.data && res.data.message);
        } else {
          toast.error(res.data && res.data.error);
        }
        dispatch(setClientPaymentsSearch([])); // reset table
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}


/*
 * Search Supplier Payments
 */
export const fetchSupplierPaymentsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/supplier/supplier-payment-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data.data && res.data.data.data.length > 0) {
          for (let sp of res.data.data.data) {
            sp.preNumberAndNumber = sp.preNumber.replace("noprefix", "") + " " + sp.number;
          }
        }
        dispatch(setSupplierPaymentsSearch(res.data.data.data));
        dispatch(setTotalItemsSPS(res.data.data.totalItems));
        dispatch(setperPageSPS(res.data.data.perPage));
        if (res.data.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        if (res.data && res.data.message) {
          toast.error(res.data && res.data.message);
        } else {
          toast.error(res.data && res.data.error);
        }
        dispatch(setSupplierPaymentsSearch([]));
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const sendMail =  (html, data, emailSettings, recipientEmails, documentType) => { //documentType: sale , clientPayment for now
  return async () => {
    let requestDataForm = new FormData();
    requestDataForm.append("from", emailSettings?.fromEmail ? emailSettings?.fromEmail.trim() : "noreply@primer.gr")
    requestDataForm.append("to", [...new Set(recipientEmails)].join())
    requestDataForm.append("company", data?.company?.trim())
    requestDataForm.append("documentType", documentType)
    requestDataForm.append("documentId", data?._id ? data?._id?.trim() : "")
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4"
    });
    doc.addFileToVFS("arial.ttf", arial);
    doc.addFont("arial.ttf", "Arial", "normal");
    doc.setFont("Arial");
    doc.setFontSize(8);

    // TEMP FIX TO THE MULTIPLE PAGE MARGIN PROBLEM
    const pages = html.querySelectorAll('.sales-print-template-show');
    pages.forEach((page, index) => {
      if (index === 0) return;
      page.style.marginTop = "259px";
    })

    await doc.html(html, {
      callback: function (doc) {
        // Save the PDF
        requestDataForm.append("file", (doc.output('datauristring').split('base64,')[1]))
      },
      html2canvas: {scale: 0.215},
      x: 20,
    });
    axios
        .post(`${apiURL2}/settings/send-email`, (requestDataForm))
        .then((res) => {
          if (res.status === 200) {
            if (res.data.status === '200' && res.data.message === "send email") {
              toast.success("Email sent successfully to recipients!");
            } else {
              toast.error(res.data.message)
            }
          }
        })
        .catch((error) => {
          console.log(error)
          toast.error(error);
        });
  }
}
/*
 * Fetch Primer My Data Data
 */
export const fetchPrimerMyDataData = (data) => {
  return (dispatch) => {
    try {
      axios.post(apiURL2 + `/settings/get-primer-mydata-data/`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
        .then(res => {
          if (res.data && res.data.status === '200') {
            if (res.data.data.length > 0) {
              dispatch(setPrimerMyDataData(res.data.data["0"]));
            }
          } else if(res.data && res.data.status === '422'){
              let pMDDSettings = SETTINGS.primerMyDataDataInitialValue;
              pMDDSettings = {...pMDDSettings, vat: JSON.stringify(vatCategoryData)}
              pMDDSettings = {...pMDDSettings, withHoldTaxes: withHoldingTaxesData}
              pMDDSettings = {...pMDDSettings, otherTaxes: otherTaxesData}
              pMDDSettings = {...pMDDSettings, fees: feesData}
              pMDDSettings = {...pMDDSettings, otherData: otherDataInitialValues}
              pMDDSettings = {...pMDDSettings, stamp: taxStampCategoryData}
              pMDDSettings = {...pMDDSettings, highlight: JSON.stringify(highlightData)}
              pMDDSettings = {...pMDDSettings, paymentWays: JSON.stringify(paymentTypesData)}
              pMDDSettings = {...pMDDSettings, measurementUnits: JSON.stringify(measurementUnitsData)}
              pMDDSettings = {...pMDDSettings, salePurpose: JSON.stringify(salesPurposeData)}
              let pMDDRequestData = {
                  year: data?.year,
                  company:data?.company,
              }
              pMDDSettings = {...pMDDSettings, ...pMDDRequestData}
              dispatch(setPrimerMyDataData(pMDDSettings));
              dispatch(putPrimerMyDataData(pMDDSettings));
          }
        }).catch((error) => {
          console.log(error);
      })
    } catch (error) {
      console.log(error?.response?.data?.errors);
    }
  }
}

export const fetchEmailSmtp = (data) => {
  return (dispatch) => {
    try {
      axios.post(apiURL2 + `/settings/get-email-smtp/`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
          .then(res => {
            if (res.data && res.data.status === '200') {
              if (res.data.data.length > 0) {
                dispatch(setEmailSmtp(res.data.data["0"]));
              }
            } else if(res.data && res.data.status === '422'){
              let smtpSettings = SETTINGS.companyEmailSmtp;
              let pMDDRequestData = {
                company:data?.company,
              }
              smtpSettings = {...smtpSettings, ...pMDDRequestData}
              dispatch(setEmailSmtp(smtpSettings));
              dispatch(putCompanyEmailSmtp(smtpSettings));
            }
          }).catch((error) => {
            console.log(error);
      });
    } catch (error) {
      console.log(error?.response?.data?.errors);
    }
  };
};

/*
 * Update Primer MyData Data
 */
export const putPrimerMyDataData = (data, onSuccess) => {
  return (dispatch) => {
    try {
      axios.put(`${apiURL2}/settings/update-primer-mydata-data`, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" }
      }).then((res) => {
        if (res.data && res.data.status === "200") {
          toast.success(res.data.message);
          dispatch(setSavePrimerMyDataData(false))
          if (onSuccess) onSuccess();
        } else {
          toast.error(res.data.errors);
        }
      });
    } catch (error) {
      console.log(error?.response?.data?.errors);
    }
  }
}

export const putCompanyEmailSmtp = (data, onSuccess) => {
  return (dispatch) => {
    try {
      axios.put(`${apiURL2}/settings/update-email-smtp`, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" }
      }).then((res) => {
        if (res.data && res.data.status === "200") {
          toast.success(res.data.message);
          dispatch(setSaveEmailSmtp(false));
          if (onSuccess) onSuccess();
        } else {
          toast.error(res.data.message);
        }
      })
    } catch (error) {
      console.log(error?.response?.data?.errors);
    }
  }
}

export const fetchCompanyInstallations = (data) => {
    return (dispatch) => {
        axios.post(apiURL2 + `/company/installations`, {companyId: data}, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.data.length > 0) {
                    let data = res.data.data;
                    data.forEach((install, i) => {
                        install.no = ++i;
                    });
                    dispatch(setCompanyInstallations(data));
                    if (res.data?.erganiInstallations?.length > 0) {
                        const arr = res.data.erganiInstallations.map((o) => {
                            return {
                                installationMasterId: o.installationMasterId,
                                address: `${o.installationMasterId === "0" ? "Κεντρικό" : `Υποκατάστημα ${o.installationMasterId}`} ${o.address}`,
                            }
                        })
                        dispatch(setErganiInstallations(arr));
                    } else {
                        const arr = data.map((o) => {
                            return {
                                installationMasterId: o.installationMasterId,
                                address: `${o.address} ${o.city} ${o.postalCode}`,
                            }
                        })
                        dispatch(setErganiInstallations(arr));
                    }
                }
            }
        }).catch((err) => {
            if (err) {
                toast.error("Service is unavailable for the moment. Please try again later.");
            }
        });
    }
}

export const fetchCompanyDetails = (data) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(
          `${apiURL2}/company/details`,
          { _id: data },
          { headers: { "Content-Type": "application/json" } }
      );

      if (res.data.status === "200") {
        let companyData = res.data.data;
        if (companyData.primaryCompany && !companyData.automaticBankTransactionsEmailFetching) {
          try {
            const primaryRes = await axios.post(
                `${apiURL2}/company/details`,
                { _id: companyData.primaryCompany },
                { headers: { "Content-Type": "application/json" } }
            );

            if (primaryRes.data.status === "200" && primaryRes.data.data) {
              companyData.automaticBankTransactionsEmailFetching = primaryRes.data.data.automaticBankTransactionsEmailFetching;
            }
          } catch (err) {
            console.error("Failed to fetch primary company details:", err);
          }
        }

        if (!isEmpty(companyData.prescriptionUsername) && !isEmpty(companyData.prescriptionPassword)) {
          dispatch(setCompanyHasPrescription(true));
        }

        dispatch(setCompanyDetails(companyData));

        if (res.data.aiSettings) {
          dispatch(setAISettings(res.data.aiSettings));
        }
      }
    } catch (err) {
      if (err) {
        toast.error("Service is unavailable for the moment. Please try again later.");
      }
    }
  };
};

export const postUserLanguage = (data) => {
  return () => {
    try {
      let requestData = {
        userId: data.userId,
        language: data.language
      }
      axios
          .post(apiURL2 + `/user/language`, requestData)
          .then((res) => {
            if (res.data.status === "200") {
              localStorage.setItem("user", JSON.stringify(res.data.data));
                toast.success(res.data.message);
            }
          })
          .catch((err) => {
            if (err) {
              toast.error("Service is unavailable for the moment. Please try again later.");
            }
          });
    } catch (error) {
      if (error) {
        toast.error("Service is unavailable for the moment. Please try again later.");
      }
    }
  }
}

export const activateMyData = (data, setLoader) => {
  return (dispatch) => {
    try {
      const permissions = JSON.parse(localStorage.getItem("user")).permissions;
      const isEpay = permissions?.find((el) => el.permissionName === "custom-epay" || el.permissionName === "custom-peiraios" || el.permissionName === "custom-daras");
      const isCardlink = permissions?.find((el) => el.permissionName === "custom-cardlink");
      const isEmployee = permissions?.find((el) => el.permissionName === "custom-employee");
      const isPrimerConstructor = permissions?.some((el) => el.permissionName === "custom-primerConstructor");

      if(!isEpay && !isCardlink && !isEmployee && !isPrimerConstructor) {
        let requestData = {
          companyId: data.companyId,
          userId: data.userId,
          subscriptionKey: data.subscriptionKey,
          environment: data.environment,
          myDataMode: data.myDataMode
        }
        if (data.accountantMyDataApiUserId) requestData.accountantMyDataApiUserId = data.accountantMyDataApiUserId;
        if (data.accountantMyDataApiSubscriptionKey) requestData.accountantMyDataApiSubscriptionKey = data.accountantMyDataApiSubscriptionKey;
        axios
            .post(apiURL2 + `/company/activateMyData`, requestData, { headers: { 'Content-Type': 'application/json' } })
            .then((res) => {
              if (res.data.status === "200") {
                toast.success(res.data.message);
                dispatch(fetchPrimerMyDataCredentials(data.companyId));
              } else {
                toast.error(res.data.message);
              }
              if (typeof setLoader === 'function') {
                setLoader(false);
              }
            })
            .catch((err) => {
              if (err) {
                toast.error("Service is unavailable for the moment. Please try again later.");
                if (typeof setLoader === 'function') {
                  setLoader(false);
                }
              }
            });
      }
    } catch (error) {
        toast.error("Service is unavailable for the moment. Please try again later.");
        if (typeof setLoader === 'function') {
          setLoader(false);
        }
    }
  }
}

export const activatePrimerMyData = (data, setLoader, refetch) => {
  return (dispatch) => {
    try {
      const permissions = JSON.parse(localStorage.getItem("user")).permissions;
      const isEpay = permissions?.find((el) => el.permissionName === "custom-epay" || el.permissionName === "custom-peiraios" || el.permissionName === "custom-daras");
      const isCardlink = permissions?.find((el) => el.permissionName === "custom-cardlink");
      const isEmployee = permissions?.find((el) => el.permissionName === "custom-employee");
      const isPrimerConstructor = permissions?.some((el) => el.permissionName === "custom-primerConstructor");

      if(!isEpay && !isCardlink && !isEmployee && !isPrimerConstructor) {
        axios.post(apiURL2 + `/company/activatePrimerMyData`, data, {
          headers: { 'Content-Type': 'application/json' }
        }).then((res) => {
          console.log(res.data);
          if (res.data.status === "200") {
            if (res.data.primerMyDataToExpire === true) {
              dispatch(setShowPrimerMyDataToExpireModal(true));
              dispatch(setPrimerMyDataModalLink(res.data.primerMyDataToExpireLink));
              dispatch(setPrimerMyDataExpirationModalMessage(res.data.expirationMessage));
            }
            if(refetch) dispatch(fetchPrimerMyDataCredentials(data.companyId, true));
            toast.success(res.data.message);
            if (typeof setLoader === 'function') {
              setLoader(false);
            }
          } else {
            toast.error(res.data.message?.Error ? res.data.message.Error : res.data.message);
            if (typeof setLoader === 'function') {
              setLoader(false);
            }
          }
        }).catch((err) => {
          if (err) {
            toast.error("Service is unavailable for the moment. Please try again later.");
            if (typeof setLoader === 'function') {
              setLoader(false);
            }
          }
        })
      }
    } catch (error) {
      if (error) {
        toast.error("Service is unavailable for the moment. Please try again later.");
        if (typeof setLoader === 'function') {
          setLoader(false);
        }
      }
    }
  }
}

export const fetchPrimerMyDataCredentials = (data, dontActivate, setEnablePrimerMyDataProviderSettings) => {
  return (dispatch) => {
    try {
      let requestData = {
        companyId: data,
      };
      axios.post(apiURL2 + `/company/get-primer-mydata-credentials/`, requestData, { headers: { 'Content-Type': 'application/json' } })
          .then(res => {
            if (res.data && res.data.status === "200") {
              let initialSettings = SETTINGS.primerApiInitialData;
              initialSettings = {...initialSettings, ...res.data.data}
                dispatch(setPrimerApiData(initialSettings));
              if(initialSettings?.username && initialSettings?.password && initialSettings?.serialNumber){
                if (typeof setEnablePrimerMyDataProviderSettings === 'function') {
                  setEnablePrimerMyDataProviderSettings(true);
                }
                if(!dontActivate) {
                  dispatch(activatePrimerMyData({
                    companyId: data,
                    username: initialSettings.username,
                    password: initialSettings.password,
                    serialNumber: initialSettings.serialNumber,
                    environment: initialSettings.primerEnvironment,
                  }));
                }
              }
            } else if(res.data && res.data.status === "422"){
              toast.error(res.data.message);
            }
          });
    } catch (error) {
      console.log(error?.response?.data?.errors);
    }
  };
};

export const sendInvoiceToMyData = (data, handleDpActions = null, setLoader) => {
  return (dispatch) => {
    try {
      setLoader(true);
      let requestJsonData = {
        saleId: data.saleId,
        companyId: data.companyId,
      }
      axios.post(apiURL2 + `/sale/send-invoice-mydata/`, requestJsonData, { headers: { 'Content-Type': 'application/json' } })
          .then((res) => {
            if (res.data && res.data.status === "200") {
              if(res.data.data?.myDataError !== "" &&  res.data.data?.myDataError !== undefined){
                toast.error(res.data.data?.myDataError);
              } else {
                toast.success("Sales sent successfully to MyData.");
              }
              dispatch(fetchAdvancedTypesSales({ company: data.companyId }));
              dispatch(setEditSales(res.data.data));
              // Used in Data Panel index to show print on save
              if (handleDpActions !== null) {
                handleDpActions("printOnSave");
              }
              dispatch(resetNewSales());
              dispatch(setSaveSales(false)); // Set save status false
              dispatch(addToForceRefresh("Sales Search"));
            } else {
              toast.error(res.data.error);
            }
            setLoader(false);
          })
          .catch((error) => {
            if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.errors
            ) {
              toast.error(error.response.data.errors);
            }
            setLoader(false);
          });
    } catch (error) {
      console.log(error);
    }
  }
}

export const sendAccountingRecordToMyData = (data, handleDpActions = null, setLoader) => {
  return (dispatch) => {
    setLoader(true);
    axios.post(apiURL2 + `/accounting/send-accounting-record-to-mydata`, data, {
      headers: {'Content-Type': 'application/json'}
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data?.myDataError !== "" && res.data.data?.myDataError !== undefined) {
          toast.error(res.data.data?.myDataError);
        } else {
          toast.success("Accounting Record successfully to MyData.");
        }
        dispatch(setEditAccountingRecord(res.data.data));
        dispatch(setForceRefreshAccounts(true));
      } else {
        toast.error(res.data.message);
      }
      setLoader(false);
    }).catch((error) => {
      console.log(error);
      setLoader(false);
    })
  }
}

export const sendFixedAssetRecordToMyData = (data, setLoader) => {
    return (dispatch) => {
        setLoader(true);
        axios.post(apiURL2 + `/fixedassets/send-fixed-asset-record-to-mydata`, data, {
            headers: {'Content-Type': 'application/json'}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data?.myDataError !== "" && res.data.data?.myDataError !== undefined) {
                    toast.error(res.data.data?.myDataError);
                } else {
                    toast.success("Η απόσβεση στάλθηκε επιτυχώς στο MyData.");
                }
                dispatch(setEditFixedAssetRecord(res.data.data));
                dispatch(addToForceRefresh("Fixed Asset Records Search"));
            } else {
                toast.error(res.data.message);
            }
            setLoader(false);
        }).catch((error) => {
            console.log(error);
            setLoader(false);
        })
    }
}

export const testSmtpConnection = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/settings/test-smtp-connection/`, data, {
      headers: { 'Content-Type': 'application/json' }
    }).then(res => {
      console.log(res.data)
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message)
      } else if(res.data && res.data.status === "422") {
        toast.error(res.data.message);
        dispatch(setSaveEmailSmtp(false));
      }
    }).catch((err) => {
      console.log(err);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const cancelMyDataSale = (data, setModal, setButton) => {
  return (dispatch) => {
    setButton(true);
    try {
      axios.post(apiURL2 + `/sale/cancelMyDataInvoice`, JSON.stringify(data), {
        headers: {"Content-Type": "application/json"},
      })
          .then((res) => {
            if (res.data && res.data.status === "200") {
              toast.success(res.data.message);
              dispatch(fetchAdvancedTypesSales({ company: data.company }));
              dispatch(setEditSales(res.data.data));
              dispatch(resetNewSales());
              dispatch(setSaveSales(false)); // Set save status false
              dispatch(addToForceRefresh("Sales Search"));
            } else {
              toast.error(res.data.message);
            }
            setModal(false);
            setButton(false);
          })
          .catch((error) => {
            if (error && error.response && error.response.data && error.response.data.errors) {
              toast.error(error.response.data.errors);
            }
            setModal(false);
            setButton(false);
          });
    } catch (error) {
      console.log(error?.response?.data?.errors);
    }
  }
}

export const cancelMyDataBuy = (data, setModal, setButton) => {
  return (dispatch) => {
    setButton(true);
    axios.post(apiURL2 + `/buy/cancelMyDataInvoice`, {...data}, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message);
        dispatch(setEditBuys(res.data.data));
        dispatch(setSaveEditBuys(false)); // Set save status false
        dispatch(addToForceRefresh("Buys Search"));
      } else {
        toast.error(res.data.message);
      }
      setModal(false);
      setButton(false);
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      setModal(false);
      setButton(false);
    })
  }
}

export const cancelMyDataAccountingRecord = (data, setModal, setButton) => {
  return (dispatch) => {
    setButton(true);
    try {
      axios.post(apiURL2 + "/accounting/cancelMyDataInvoice", {...data}, {
        headers: { "Content-Type": "application/json" },
      })
          .then((res) => {
            if(res.data && res.data.status === "200") {
              toast.success(res.data.message);
              dispatch(setEditAccountingRecord(res.data.data));
              dispatch(setSaveEditAccountingRecord(false));
              dispatch(addToForceRefresh("Accounting Record Search"));
            } else {
              toast.error(res.data.message);
            }
            setModal(false);
            setButton(false);
          })
          .catch((error) => {
            if (error && error.response && error.response.data && error.response.data.errors) {
              toast.error(error.response.data.errors);
            }
            setModal(false);
            setButton(false);
          });
    } catch (error) {
      console.log(error?.response?.data?.errors);
    }
  }
}

export const cancelMyDataFixedAssetRecord = (data, setModal, setButton) => {
    return (dispatch) => {
        setButton(true);
        try {
            axios.post(apiURL2 + "/fixedassets/cancelMyDataInvoice", {...data}, {
                headers: { "Content-Type": "application/json" },
            })
                .then((res) => {
                    if(res.data && res.data.status === "200") {
                        toast.success(res.data.message);
                        dispatch(setEditFixedAssetRecord(res.data.data));
                        dispatch(setSaveEditFixedAssetRecord(false));
                        dispatch(addToForceRefresh("Fixed Asset Records Search"));
                    } else {
                        toast.error(res.data.message);
                    }
                    setModal(false);
                    setButton(false);
                })
                .catch((error) => {
                    if (error && error.response && error.response.data && error.response.data.errors) {
                        toast.error(error.response.data.errors);
                    }
                    setModal(false);
                    setButton(false);
                });
        } catch (error) {
            console.log(error?.response?.data?.errors);
        }
    }
}

export const sendInvoiceToMyDataBuy = (data, handleDpActions = null, setLoader) => {
  return (dispatch) => {
    try {
      setLoader(true);
      let requestJsonData = {
        buyId: data.buyId,
        companyId: data.companyId,
      };
      axios.post(apiURL2 + `/buy/send-invoice-mydata/`, requestJsonData, { headers: { 'Content-Type': 'application/json' } })
          .then((res) => {
            if (res.data && res.data.status === "200") {
              if(res.data.data?.myDataError !== "" &&  res.data.data?.myDataError !== undefined){
                toast.error(res.data.data?.myDataError);
              } else {
                toast.success("Buys sent successfully to MyData.");
              }
              dispatch(fetchAdvancedTypesBuys({ company: data.companyId }));
              dispatch(setEditBuys(res.data.data));
              // Used in Data Panel index to show print on save
              if (handleDpActions !== null) {
                handleDpActions("printOnSave");
              }
              dispatch(resetNewBuys());
              dispatch(setSaveBuys(false)); // Set save status false
              dispatch(addToForceRefresh("Buys Search"));
            } else {
              toast.error(res.data.error);
            }
            setLoader(false);
          })
          .catch((error) => {
            setLoader(false);
            if (error && error.response && error.response.data && error.response.data.errors) {
              toast.error(error.response.data.errors);
            }
          });
    } catch (error) {
      console.log(error);
    }
  }
}

export const postEmployee = (data, requestData, setLoader, onSuccess) => {
  return (dispatch) => {
    setLoader(true);
    axios.post(apiURL2 + `/accounting/add-employee`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success("New Employee Added.");
        dispatch(resetNewEmployee()); // Reset client form
        dispatch(addToForceRefresh("Employees Search"));
        dispatch(setSendEmployeeNewPasswordOnSave(false));
        dispatch(setSendEmployeeQROnSave(false));
        if (onSuccess) onSuccess();
      } else {
        if (res.data?.specialCode === "1") {
          dispatch(setUpgradeEmployeeLimitModalData({show: true, text: res.data.message, buttonURL: res.data?.buttonURL}));
        } else {
          toast.error(res.data.message);
        }
      }
      setLoader(false);
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      setLoader(false);
    })
  }
}

export const fetchEmployeeSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/employee-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchEmployees(res.data.data.data));
        dispatch(setperPageES(res.data.data.perPage));
        dispatch(setTotalItemsES(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchEmployees([]));
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const putEmployee = (data, requestData, action = "update", setLoader, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoader === 'function') setLoader(true);
    data.id = data._id;
    axios.post(apiURL2 + `/accounting/edit-employee`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setEditEmployee(res.data.data));
        dispatch(addToForceRefresh("Employees Search"));
        dispatch(setSendEmployeeNewPasswordOnSave(false));
        dispatch(setSendEmployeeQROnSave(false));
        dispatch(setSendEmployeeChangesToErgani(false));
        toast.success("Employee updated.");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "employee", document: res.data.document}));
      } else {
        if (res.data?.specialCode === "1") {
          dispatch(setUpgradeEmployeeLimitModalData({show: true, text: res.data.message, buttonURL: res.data?.buttonURL}));
        } else {
          toast.error(res.data.message, {autoClose: 6000});
        }
      }
      if (typeof setLoader === 'function') setLoader(false);
    }).catch((error) => {
      if (typeof setLoader === 'function') setLoader(false);
      toast.error(error + " Update Employee");
    })
  }
}

export const postAccountingAccount = (data, requestData, setLoader, onSuccess) => {
  return (dispatch) => {
    setLoader(true);
    axios.post(apiURL2 + `/accounting/add-accounting-account`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        toast.success("New Accounting Account Added.");
        dispatch(resetNewAccountingAccount()); // Reset client form
        dispatch(addToForceRefresh("Accounting Account Search"));
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
      setLoader(false);
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      setLoader(false);
    })
  }
}

export const postAccountingRecord = (data, requestData, setLoader, action, isEmronConnectFileERP, dataCallback) => {
  return (dispatch) => {
    if (setLoader) setLoader(true);
    axios.post(apiURL2 + `/accounting/add-accounting-record`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (isEmronConnectFileERP) {
          localStorage.setItem(`${isEmronConnectFileERP}-status`, `200|${res.data.data._id}|${getDocumentLabel(res.data.data)}`);
          return window.close();
        }
        toast.success("New Accounting Record Added.");
        if(res.data.data?.myDataError !== "" &&  res.data.data?.myDataError !== undefined){
          toast.error(res.data.data?.myDataError);
        }
        if (action === "save") dispatch(resetNewAccountingRecord()); // Reset accounting record form
        if (action === "saveandrepeat") dispatch(softResetAccountingRecord());

        dispatch(addToForceRefresh("Accounting Record Search"));
        if (dataCallback) dataCallback(res.data.data);
      } else {
        if (res.data?.myDataError === true) dispatch(resetNewAccountingRecord()); // Reset accounting record form
        toast.error(res.data.message);
      }
      if (setLoader) setLoader(false);
    }).catch((error) => {
      if (error && error.response && error.response.data && error.response.data.errors) {
        toast.error(error.response.data.errors);
      }
      if (setLoader) setLoader(false);
    });
  }
}

export const putAccountingRecord = (data, requestData, setLoader, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoader === 'function') setLoader(true);
    data.id = data._id;
    axios.post(apiURL2 + `/accounting/edit-accounting-record`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setEditAccountingRecord(res.data.data));
        dispatch(setForceRefreshAccounts(true));
        dispatch(addToForceRefresh("Accounting Record Search"));
        toast.success("Accounting Record updated.");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "accounting-record", document: res.data.document}));
      } else {
        toast.error(res.data.message);
      }
      if (typeof setLoader === 'function') setLoader(false);
    }).catch((error) => {
      if (typeof setLoader === 'function') setLoader(false);
      toast.error(error + " Update Accounting Record");
    })
  }
}

export const fetchAccountingRecordSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/accounting-record-search`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if(res.data.data.data.length > 0) {
          for (let item of res.data.data.data) {
            item.preNumberAndNumber = item.preNumber.replace("noprefix", "") + " " + item.number;
          }
        }
        dispatch(setSearchAccountingRecords(res.data.data.data));
        dispatch(setperPageAR(res.data.data.perPage));
        dispatch(setTotalItemsAR(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchAccountingRecords([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchAccountingAccountSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/accounting/accounting-account-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchAccountingAccounts(res.data.data.data));
        dispatch(setperPageAAS(res.data.data.perPage));
        dispatch(setTotalItemsAAS(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchAccountingAccounts([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const putAccountingAccount = (data, requestData, action = "update", setLoader, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoader === 'function') setLoader(true);
    data.id = data._id;
    axios.post(apiURL2 + `/accounting/edit-accounting-account`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        dispatch(setEditAccountingAccount(res.data.data));
        dispatch(addToForceRefresh("Accounting Account Search"));
        toast.success("Accounting Account updated.");
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "accounting-account", document: res.data.document}));
      } else {
        toast.error(res.data.message);
      }
      if (typeof setLoader === 'function') setLoader(false);
    }).catch((error) => {
      if (typeof setLoader === 'function') setLoader(false);
      toast.error(error + " Update Accounting Account");
    })
  }
}

export const getSubscriptions = (reqData) => {
  return (dispatch) => {
    axios.get(apiURL2 + `/settings/get-subscriptions`, {
      headers: { "Content-Type": "application/json" },
      params: reqData
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSubscriptions(res.data.data));
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}
export const deleteSubscription = (reqData) => {
  return (dispatch) => {
    axios.get(apiURL2 + `/settings/delete-subscription`, {
      headers: { "Content-Type": "application/json" },
      params: reqData
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(getSubscriptions({company: reqData.company}));
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}
export const endTelephoneSupport = (company, client, sub, supportTime) => {
  return () => {
    axios.post(apiURL2 + `/settings/end-telephone-support`, {company: company, client: client, sub: sub, supportTime: String(supportTime)}, {
      headers: { "Content-Type" : "application/json" },
    }).then((res) => {
      if(res.data.status === "200") {
        toast.success("Η υποστήριξη έληξε και η χρονοχρέωση αποθηκεύτηκε.");
      } else if (res.data.status === "400") {
        toast.error(res.data.message);
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

export const fetchAccountingPaymentTypes = (company) => {
  return (dispatch) => {
    axios.get(process.env.REACT_APP_API_URL2 + "/accounting/get-payment-types", {
      headers: { "Content-Type": "application/json" },
      params: {
        company: company.id
      }
    }).then((response) => {
      if(response.data.status === "200") {
        dispatch(setAccountingPaymentTypes(response.data.data));
      } else {
        toast.error(response.data.message);
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

export const fetchCashSettings = (companyID) => {
  return (dispatch) => {
    axios.get(process.env.REACT_APP_API_URL2 + "/cash/fetch-cash-settings", {
      headers: { "Content-Type": "application/json" },
      params: {
        company: companyID
      }
    }).then((res) => {
      if (res.data?.status === "200" && res.data?.data) {
        dispatch(setCashSettings(res.data.data));
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

export const postCashSettings = (postData, setLoader, onSuccess) => {
  return (dispatch) => {
    if (setLoader) setLoader(true);
    axios.post(process.env.REACT_APP_API_URL2 + "/cash/post-cash-settings", postData, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        toast.success(res.data.message);
        dispatch(fetchCashSettings(postData.company));
        if (onSuccess) onSuccess();
      } else if(res.data?.specialCode === "911") {
        dispatch(setRefreshEditModalData({show: true, documentType: "cash-settings", document: res.data.document}));
      } else {
        toast.error(res.data.message);
      }
      if (setLoader) setLoader(false);
    }).catch((err) => {
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      console.log(err);
      if (setLoader) setLoader(false);
    })
  }
}

export const fetchPayrollSettings = (company) => {
  return (dispatch) => {
    axios.get(process.env.REACT_APP_API_URL2 + "/payroll/fetch-settings", {
      headers: { "Content-Type": "application/json" },
      params: {
        company: company
      }
    }).then((res) => {
      if (res.data.status === "200") {
        if (res.data.payrollSettings) {
          dispatch(setPayrollSettings(res.data.payrollSettings));
        }
        if (res.data.hasErgani) {
          dispatch(setCompanyHasErgani(true));
        }
      }
    }).catch((err) => {
      console.log(err);
    })
  }
}

export const postWorkMovement = (data, setLoadingSave, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoadingSave === "function") setLoadingSave(true);
    axios.post(`${process.env.REACT_APP_API_URL2}/payroll/post-work-movement`, {
      ...data
    }, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (typeof setLoadingSave === "function") setLoadingSave(false);
      if (res.data.status === "200") {
        toast.success("Η κίνηση εργαζομένου έγινε επιτυχώς.");
        dispatch(resetNewWorkMovement());
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (typeof setLoadingSave === "function") setLoadingSave(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchWorkMovementsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/payroll/work-movements-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchWorkMovements(res.data.data.data));
        dispatch(setSearchWorkMovementsPerPage(res.data.data.perPage));
        dispatch(setSearchWorkMovementsTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchWorkMovements([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const postWorkPermit = (data, setLoader, onSuccess) => {
  setLoader(true);
  return (dispatch) => {
    axios.post(apiURL2 + "/payroll/post-work-permit", data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      setLoader(false);
      if (res.data.status === "200") {
        dispatch(addToForceRefresh("Work Permits Search"));
        toast.success("Οι άδειες αποθηκεύτηκαν επιτυχώς.");
        dispatch(resetNewWorkPermit());
        if (onSuccess) onSuccess();
      } else {
        dispatch(setSaveNewWorkPermit(true));
        toast.error(res.data.message, {autoClose: 7000});
      }
    }).catch((error) => {
      dispatch(setSaveNewWorkPermit(true));
      setLoader(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const putWorkPermit = (data, setLoader, onSuccess) => {
  setLoader(true);
  return (dispatch) => {
    axios.post(apiURL2 + "/payroll/update-work-permit", data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      setLoader(false);
      if (res.data.status === "200") {
        dispatch(addToForceRefresh("Work Permits Search"));
        toast.success("Οι άδειες αποθηκεύτηκαν επιτυχώς.");
        if (onSuccess) onSuccess();
      } else {
        dispatch(setSaveEditWorkPermit(true));
        toast.error(res.data.message, {autoClose: 7000});
      }
    }).catch((error) => {
      dispatch(setSaveEditWorkPermit(true));
      setLoader(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchWorkPermitsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/payroll/work-permits-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchWorkPermits(res.data.data.data));
        dispatch(setSearchWorkPermitsPerPage(res.data.data.perPage));
        dispatch(setSearchWorkPermitsTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchWorkPermits([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchCompanyStatus = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/emron/company-status`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setEmronCompanyInvalid(!res.data.valid));
        dispatch(setCanBypassInvalidCompany(res.data.canBypass));
        dispatch(setEmronCompanyInvalidDays(res.data.lastOrderDateDiff));
        dispatch(setIsEmronClient(res.data.isEmronClient));
        if (res.data.clientData) {
          if (Object.keys(res.data.clientData).length > 0) {
            dispatch(setEmronClientData(res.data.clientData));
          } else {
            dispatch(setEmronClientData(null));
          }
        } else {
          dispatch(setEmronClientData(null));
        }
        if (res.data.isEmron) {
          dispatch(setIsEmron(res.data.isEmron));
        }
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const postAccountingClosure = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/accounting/accounting-closure`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής εγγραφή κλεισίματος.");
        dispatch(setSaveNewAccountingClosure(false))
        dispatch(resetNewAccountingClosure());
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const postNewVisit = (data, setLoading, company, TABS_DATA, successfulCallback) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + "/prescription/new-visit", data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        dispatch(checkForActiveVisit(company, TABS_DATA));
        dispatch(resetNewVisit());
        toast.success("Επιτυχής άνοιγμα επίσκεψης.");
        if (successfulCallback) {
          if (typeof successfulCallback === "function") successfulCallback();
        }
      } else {
        if (res.data?.specialCode === "1") {
          dispatch(setNewVisitOverrideModal({
            show: true,
            text: res.data?.extraDetails?.description,
            overrideTypeId: res.data?.extraDetails?.overrideTypeId,
            overrideReasonId: "",
            isChecked: "",
          }))
          dispatch(setSaveNewVisit(true));
          toast.warning(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const postActiveVisit = (data, setLoading, company, TABS_DATA, action, selectedReferralBarcodes = []) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + "/prescription/complete-visit", {...data, selectedReferralBarcodes: selectedReferralBarcodes}, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      dispatch(setSaveActiveVisit(true));
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής ολοκλήρωση επίσκεψης.");
        dispatch(resetActiveVisit());
        dispatch(resetNewVisit());
        if (action === "save") {
            dispatch(openEditVisit({id: data.visitId}, TABS_DATA));
        } else if (action === "saveandrepeat") {
            dispatch(openNewVisit(TABS_DATA));
        } else if (action === "activeVisitNewSale") {
          if (res.data?.settings) {
            const referralArray = res.data?.referralArray;
            const settings = res.data?.settings;
            if (settings.autoSaleDocumentType) {
              const corVisitData = {
                documentType: settings.autoSaleDocumentType,
                documentTypeName: settings.autoSaleDocumentTypeName,
                autoSaleProduct: String(data.inQuota) === "false" ? settings.autoSaleProduct : "",
                autoSaleProductQuantity: 1,
                client: data.client,
                referralArray: referralArray || [],
              }
              dispatch(setCorrelatedVisitData(corVisitData));
            }
          }
          dispatch(openNewSale(TABS_DATA));
        }
        setTimeout(() => {
          dispatch(removeTab("visit-active"));
        }, 150)
      } else {
        toast.error(res.data.message, {autoClose: 6000});
      }
    }).catch((error) => {
      dispatch(setSaveActiveVisit(true));
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const checkForActiveVisit = (company, TABS_DATA, setLoader) => {
  return (dispatch) => {
    if (typeof setLoader === "function") setLoader(true);
    axios.get(`${process.env.REACT_APP_API_URL2}/prescription/active-visit`, {
      headers: { "Content-Type": "application/json" },
      params: {
        company: company.id,
      }
    }).then((res) => {
      if (typeof setLoader === "function") setLoader(false);
      if (res.data.status === "200" && res.data.specialCode === "1") {
        dispatch(setActiveVisit(res.data.data));
        dispatch(setActiveVisitClientData(res.data.clientData));
        dispatch(removeTab("visit-new"));
        dispatch(openTabByType("visit-active", TABS_DATA));
        dispatch(setActiveVisitFirstLoad(true));
      }
    }).catch((err) => {
      if (typeof setLoader === "function") setLoader(false);
      console.log(err);
    })
  }
}

export const fetchVisitsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/prescription/visits-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchVisits(res.data.data.data));
        dispatch(setSearchVisitsPerPage(res.data.data.perPage));
        dispatch(setSearchVisitsTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchVisits([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchPrescriptionsSearch = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/prescription/prescriptions-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchPrescriptions(res.data.data.data));
        dispatch(setSearchPrescriptionsPerPage(res.data.data.perPage));
        dispatch(setSearchPrescriptionsTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchPrescriptions([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchPrescriptionsReferrals = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/prescription/referrals-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchReferrals(res.data.data.data));
        dispatch(setSearchReferralsPerPage(res.data.data.perPage));
        dispatch(setSearchReferralsTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchReferrals([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchUserSettings = (userId, permissionData) => {
  return (dispatch) => {
    const userId = JSON.parse(localStorage.getItem("user"))._id;
    axios.get(`${process.env.REACT_APP_API_URL2}/user/user-settings`, {
      headers: { "Content-Type": "application/json" },
      params: {userId: userId}
    }).then(res => {
      if (res.data.status === "200" && res.data.userSettings) {
        dispatch(setUserSettings(res.data.userSettings));
      }
      if (res.data.status === "200" && String(res.data.showReleaseNotes) === "true" && checkPermission("custom-releaseNotes", permissionData)) {
        dispatch(setShowReleaseNotesModal(true));
      }
    }).catch(e => {
      console.log(e);
      toast.error("Σφάλμα κατά την άντληση ρυθμίσεων χρήστη.");
    });
  }
}

export const fetchSearchICD10s = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/prescription/icd10s-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchICD10s(res.data.data.data));
        dispatch(setSearchICD10sPerPage(res.data.data.perPage));
        dispatch(setSearchICD10sTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchReferrals([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchSearchDrugs = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/prescription/drugs-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchDrugs(res.data.data.data));
        dispatch(setSearchDrugsPerPage(res.data.data.perPage));
        dispatch(setSearchDrugsTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchDrugs([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchSearchExams = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/prescription/exams-search`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchExams(res.data.data.data));
        dispatch(setSearchExamsPerPage(res.data.data.perPage));
        dispatch(setSearchExamsTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchExams([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchActiveDcl = (data, TABS_DATA, showToast = false) => {
  return (dispatch) => {
    dispatch(setMainActiveDclLoader(true));
    axios.post(apiURL2 + `/dcl/fetch-active-dcl`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      dispatch(setMainActiveDclLoader(false));
      if (res.data.status === "200") {
        if(showToast) toast.success("Επιτυχής Ενημέρωση Εγγραφών!");
        dispatch(setActiveDcl(res.data.data));
      } else if(res.data.status === "415") {
        dispatch(setActiveDcl([]));
        dispatch(removeTab("new-dcl"));
        dispatch(openTabByType("primer-my-data", TABS_DATA));
        toast.error("Παρακαλώ εισάγετε κωδικούς MyData για να κάνετε χρήση του Ψηφιακού Πελατολογίου");
      } else {
        if(showToast) toast.info("Δεν βρέθηκαν Εγγραφές!");
        dispatch(setActiveDcl([]));
      }
    }).catch((error) => {
      dispatch(setActiveDcl([]));
      dispatch(setMainActiveDclLoader(false));
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const postNewDcl = (data, setLoading, requestData, setModalShow) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/dcl/add-dcl`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής Εγγραφή Ψηφιακού Πελατολογίου.");
        if(setModalShow) setModalShow(false);
        dispatch(setNewDcl({...newDclInitialValue, clientServiceType: requestData.clientServiceType, installation: requestData.installation}));
        dispatch(setDclRequestData({...requestData, dclStatus: "open", forceRefresh: true}));
        dispatch(addToForceRefresh("Dcl Search"));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const cancelDclEntry = (data, setLoading,  setModalShow) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/dcl/cancel-dcl`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής Ακύρωση Εγγραφής Ψηφιακού Πελατολογίου.");
        if(setModalShow) setModalShow(false);
        dispatch(setSelectedDcl(res.data.data));
        dispatch(setForceRefreshDclActive(true));
        dispatch(addToForceRefresh("Dcl Search"));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const cancelDclEntryPage = (data, setLoading,  setModalShow) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/dcl/cancel-dcl`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής Ακύρωση Εγγραφής Ψηφιακού Πελατολογίου.");
        if(setModalShow) setModalShow(false);
        dispatch(setEditDcl(res.data.data));
        dispatch(addToForceRefresh("Dcl Search"));
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const postEditDcl = (data, setLoading, issueInvoice, TABS_DATA) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/dcl/edit-dcl`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής Ενημέρωση Εγγραφή Ψηφιακού Πελατολογίου.");
        dispatch(setSelectedDcl(res.data.data));
        dispatch(setForceRefreshDclActive(true));
        dispatch(addToForceRefresh("Dcl Search"));
        if(issueInvoice) {
          dispatch(setCorrelatedDclData(data));
          dispatch(setShowDclAfterSaleNew(true));
          dispatch(openNewSale(TABS_DATA));
        }
        if(String(res.data.data?.entryCompletion) === "true") {
          dispatch(setShowSelectedDclModal(false));
        }
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const postEditDclPage = (data, setLoading, issueInvoice, TABS_DATA) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/dcl/edit-dcl`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής Ενημέρωση Εγγραφή Ψηφιακού Πελατολογίου.");
        dispatch(setEditDcl(res.data.data));
        dispatch(addToForceRefresh("Dcl Search"));
        if(issueInvoice) {
          dispatch(setCorrelatedDclData(data));
          dispatch(setShowDclPageAfterSaleNew(true));
          dispatch(openNewSale(TABS_DATA));
        }
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchDcls = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/dcl/search-dcl`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSearchDcl(res.data.data.data));
        dispatch(setSearchDclPerPage(res.data.data.perPage));
        dispatch(setSearchDclTotalItems(res.data.data.totalItems));
        if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
        if (cb) cb();
      } else {
        dispatch(setSearchDcl([]));
        toast.error(res.data && res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const sendDclToMyData = (data, setLoading, isFromEdit = false) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/dcl/send-dcl-mydata`, data, {
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (setLoading) setLoading(false);
      if (res.data.status === "200") {
        toast.success("Επιτυχής Αποστολή στο MyData!");
        if(isFromEdit) {
          dispatch(setEditDcl(res.data.data));
        } else {
          dispatch(setSelectedDcl(res.data.data));
        }
        dispatch(setForceRefreshDclActive(true));
        dispatch(addToForceRefresh("Dcl Search"));
      } else {
        if(res.data?.data) {
          if (isFromEdit) {
            dispatch(setEditDcl(res.data.data));
          } else {
            dispatch(setSelectedDcl(res.data.data));
          }
        }
        toast.error(res.data.message);
      }
    }).catch((error) => {
      if (setLoading) setLoading(false);
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    })
  }
}

export const fetchFixedAssetsSettings = (companyId) => {
    return (dispatch) => {
        axios.get(`${process.env.REACT_APP_API_URL2}/fixedassets/fetch-settings`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: companyId,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setFixedAssetsSettings(res.data.data));
            }
        }).catch((err) => {
            console.log(err);
        })
    }
}

export const postFixedAssetsSettings = (data, setLoading, onSuccess) => {
    return () => {
        if (setLoading) setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/post-settings`, {
            ...data,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής αποθήκευση.");
                if (onSuccess) onSuccess();
            } else {
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((err) => {
            if (setLoading) setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const postFixedAsset = (data, SALES, BUYS, setLoading, onSuccess) => {
    return (dispatch) => {
        if (setLoading) setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/post-fixed-asset`, {
            ...data,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής εισαγωγή.");
                dispatch(addToForceRefresh("Fixed Assets Search"));
                dispatch(resetNewFixedAsset());
                dispatch(fetchFixedAssetsSettings(data.company));
                if (data.correlatedSaleHistory) selfUpdateSale(dispatch, SALES, data.company, data.correlatedSaleHistory);
                if (data.correlatedSale) selfUpdateSale(dispatch, SALES, data.company, data.correlatedSale);
                if (data.correlatedBuyHistory) selfUpdateBuy(dispatch, BUYS, data.company, data.correlatedBuyHistory);
                if (data.correlatedBuy) selfUpdateBuy(dispatch, BUYS, data.company, data.correlatedBuy);
                if (onSuccess) onSuccess();
            } else {
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((err) => {
            if (setLoading) setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const updateFixedAsset = (data, SALES, BUYS, setLoading, successfulCallback) => {
    return (dispatch) => {
        if (setLoading) setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/update-fixed-asset`, {
            ...data,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής επεξεργασία.");
                dispatch(setEditFixedAsset(res.data.data));
                dispatch(addToForceRefresh("Fixed Assets Search"));
                dispatch(fetchFixedAssetsSettings(data.company));
                if (data.correlatedSaleHistory) selfUpdateSale(dispatch, SALES, data.company, data.correlatedSaleHistory);
                if (data.correlatedSale) selfUpdateSale(dispatch, SALES, data.company, data.correlatedSale);
                if (data.correlatedBuyHistory) selfUpdateBuy(dispatch, BUYS, data.company, data.correlatedBuyHistory);
                if (data.correlatedBuy) selfUpdateBuy(dispatch, BUYS, data.company, data.correlatedBuy);
                if (data?.additionalImprovements?.length > 0) {
                    for (const ai of data.additionalImprovements) {
                        selfUpdateBuy(dispatch, BUYS, data.company, ai.correlatedBuy);
                    }
                }
                if (successfulCallback) successfulCallback();
            } else if (res.data?.specialCode === "911") {
                dispatch(setRefreshEditModalData({show: true, documentType: "fixed-asset", document: res.data.document}));
            } else {
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((err) => {
            if (setLoading) setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const fetchFixedAssets = (data, cb) => {
    return (dispatch) => {
        axios.post(apiURL2 + `/fixedassets/search-fixed-assets`, data, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setSearchFixedAssets(res.data.data.data));
                dispatch(setSearchFixedAssetsPerPage(res.data.data.perPage));
                dispatch(setSearchFixedAssetsTotalItems(res.data.data.totalItems));
                if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
                if (cb) cb();
            } else {
                dispatch(setSearchFixedAssets([]));
                toast.error(res.data && res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const fetchFixedAssetMovements = (data, cb) => {
    return (dispatch) => {
        axios.post(apiURL2 + `/fixedassets/search-fixed-asset-movements`, data, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setSearchFixedAssetMovements(res.data.data.data));
                dispatch(setSearchFixedAssetMovementsPerPage(res.data.data.perPage));
                dispatch(setSearchFixedAssetMovementsTotalItems(res.data.data.totalItems));
                if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
                if (cb) cb();
            } else {
                dispatch(setSearchFixedAssetMovements([]));
                toast.error(res.data && res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const postFixedAssetMovement = (data, setLoading, onSuccess) => {
    return (dispatch) => {
        if (setLoading) setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/post-fixed-asset-movement`, {
            ...data,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(fetchAdvancedTypes({company: data.company}));
                toast.success("Επιτυχής εισαγωγή.");
                dispatch(resetNewFixedAssetMovement());
                dispatch(setSaveNewFixedAssetMovement(false));
                dispatch(addToForceRefresh("Fixed Asset Movements Search"));
                if (onSuccess) onSuccess();
            } else {
                dispatch(setSaveNewFixedAssetMovement(true));
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((err) => {
            if (setLoading) setLoading(false);
            dispatch(setSaveNewFixedAssetMovement(true));
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const updateFixedAssetMovement = (data, setLoading, onSuccess) => {
    return (dispatch) => {
        if (setLoading) setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/update-fixed-asset-movement`, {
            ...data,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setSaveEditFixedAssetMovement(false));
                dispatch(addToForceRefresh("Fixed Asset Movements Search"));
                dispatch(setEditFixedAssetMovement(res.data.data));
                toast.success("Επιτυχής επεξεργασία.");
                if (onSuccess) onSuccess();
            } else if (res.data?.specialCode === "911") {
                dispatch(setRefreshEditModalData({show: true, documentType: "fixed-asset-movement", document: res.data.document}));
            } else {
                dispatch(setSaveEditFixedAssetMovement(true));
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((err) => {
            if (setLoading) setLoading(false);
            dispatch(setSaveEditFixedAssetMovement(true));
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const postFixedAssetRecord = (data, dataCallback = null, setLoading) => {
    return (dispatch) => {
        if (setLoading) setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/post-fixed-asset-record`, {
            ...data,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                if (dataCallback) dataCallback(res.data.data);
                dispatch(fetchAdvancedTypes({company: data.company}));
                dispatch(setSaveNewFixedAssetRecord(false));
                dispatch(addToForceRefresh("Fixed Asset Records Search"));
                dispatch(resetNewFixedAssetRecord());
                if (!dataCallback) toast.success("Επιτυχής εισαγωγή.");
            } else {
                dispatch(setSaveNewFixedAssetRecord(true));
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((err) => {
            if (setLoading) setLoading(false);
            dispatch(setSaveNewFixedAssetRecord(true));
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const updateFixedAssetRecord = (data, setLoading, onSuccess) => {
    return (dispatch) => {
        if (setLoading) setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/fixedassets/update-fixed-asset-record`, {
            ...data,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setSaveEditFixedAssetRecord(false));
                dispatch(addToForceRefresh("Fixed Asset Records Search"));
                dispatch(setEditFixedAssetRecord(res.data.data));
                toast.success("Επιτυχής επεξεργασία.");
                if (onSuccess) onSuccess();
            } else if (res.data?.specialCode === "911") {
                dispatch(setRefreshEditModalData({show: true, documentType: "fixed-asset-record", document: res.data.document}));
            } else {
                dispatch(setSaveEditFixedAssetRecord(true));
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((err) => {
            if (setLoading) setLoading(false);
            dispatch(setSaveEditFixedAssetRecord(true));
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const fetchFixedAssetRecords = (data, cb) => {
    return (dispatch) => {
        axios.post(apiURL2 + `/fixedassets/search-fixed-asset-records`, data, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setSearchFixedAssetRecords(res.data.data.data));
                dispatch(setSearchFixedAssetRecordsPerPage(res.data.data.perPage));
                dispatch(setSearchFixedAssetRecordsTotalItems(res.data.data.totalItems));
                if (res.data.data && res.data.data.data.length === 0) return toast.info("No records found.");
                if (cb) cb();
            } else {
                dispatch(setSearchFixedAssetRecords([]));
                toast.error(res.data && res.data.message);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const generatePrimerAiUrl = (data, setLoading) => {
    return (dispatch) => {
        if (setLoading) setLoading(true);
        axios.post(apiURL2 + `/sale/generate-primer-ai-url`, data, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                dispatch(setNewPrimerAiUrl(res.data.data));
                toast.success(res.data.message);
                const savedData = res.data.data;
                if (data.sentLinkToEmail && !isEmpty(data.email)) {
                    const emailPayload = {
                        ...savedData,
                        email: data.email
                    };

                    axios.post(apiURL2 + `/sale/send-primer-ai-url`, emailPayload, {
                        headers: {"Content-Type": "application/json"},
                    }).then((emailRes) => {
                        if (emailRes.data.status === "200") {
                            toast.success(emailRes.data.message);
                        } else {
                            toast.warning(emailRes.data.message);
                        }
                    }).catch(() => toast.error("Σφάλμα κατά την αποστολή του email."));
                }
            } else {
                toast.error(res.data.message);
            }
            if (setLoading) setLoading(false);
        }).catch((error) => {
            if (setLoading) setLoading(false);
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }
}

export const postCheque = (data, setLoading) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/cash/post-cheque`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSaveNewCheque(false));
        dispatch(resetNewCheque());
        dispatch(addToForceRefresh("Cheques Search"));
        toast.success("Επιτυχής καταχώρηση.");
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    }).finally(() => {
      if (setLoading) setLoading(false);
    })
  }
}

export const updateCheque = (data, setLoading) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/cash/update-cheque`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(addToForceRefresh("Cheques Search"));
        toast.success("Επιτυχής ενημέρωση.");
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    }).finally(() => {
      if (setLoading) setLoading(false);
    })
  }
}

export const searchCheques = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/search-cheques`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setChequeSearchData(res.data.data));
        dispatch(setChequeSearchTotalItems(res.data.totalItems));
        if (cb) cb();
      }
    }).catch((error) => {
      console.log(error);
    });
  }
}

export const fetchCheques = (data) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/list-cheque`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setChequeList(res.data.data));
      }
    }).catch((error) => {
      console.log(error);
    });
  }
}

export const postLoan = (data, setLoading) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/cash/post-loan`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSaveNewLoan(false));
        dispatch(resetNewLoan());
        dispatch(addToForceRefresh("Loans Search"));
        toast.success("Επιτυχής καταχώρηση.");
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    }).finally(() => {
      if (setLoading) setLoading(false);
    })
  }
}

export const updateLoan = (data, setLoading) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/cash/update-loan`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(addToForceRefresh("Loans Search"));
        toast.success("Επιτυχής ενημέρωση.");
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    }).finally(() => {
      if (setLoading) setLoading(false);
    })
  }
}

export const searchLoans = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/search-loans`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setLoansSearchData(res.data.data));
        dispatch(setLoansSearchTotalItems(res.data.totalItems));
        if (cb) cb();
      }
    }).catch((error) => {
      console.log(error);
    });
  }
}

export const postCard = (data, setLoading) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/cash/post-card`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setSaveNewCard(false));
        dispatch(resetNewCard());
        dispatch(addToForceRefresh("Cards Search"));
        toast.success("Επιτυχής καταχώρηση.");
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    }).finally(() => {
      if (setLoading) setLoading(false);
    })
  }
}

export const updateCard = (data, setLoading) => {
  return (dispatch) => {
    if (setLoading) setLoading(true);
    axios.post(apiURL2 + `/cash/update-card`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(addToForceRefresh("Cards Search"));
        toast.success("Επιτυχής ενημέρωση.");
      } else {
        toast.error(res.data.message);
      }
    }).catch((error) => {
      console.log(error);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
    }).finally(() => {
      if (setLoading) setLoading(false);
    })
  }
}

export const searchCards = (data, cb) => {
  return (dispatch) => {
    axios.post(apiURL2 + `/cash/search-cards`, data, {
      headers: {"Content-Type": "application/json"},
    }).then((res) => {
      if (res.data.status === "200") {
        dispatch(setCardsSearchData(res.data.data));
        dispatch(setCardSearchTotalItems(res.data.totalItems));
        if (cb) cb();
      }
    }).catch((error) => {
      console.log(error);
    });
  }
}

export const postSubmittedVatDeclarations = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoading === "function") setLoading(true);

    axios.post(`${apiURL2}/accounting/save-submitted-vat-declarations`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (typeof setLoading === "function") setLoading(false);
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message || "Οι δηλώσεις αποθηκεύτηκαν επιτυχώς στη βάση!");
        dispatch(addToForceRefresh("Submitted Vat Declarations Search"));
        if (onSuccess) onSuccess(res.data.data);
      } else {
        toast.error(res.data.message || "Σφάλμα κατά την αποθήκευση στη βάση.");
      }
    }).catch((err) => {
      if (typeof setLoading === "function") setLoading(false);
      console.error("Save submitted VAT error:", err);
      toast.error("Σφάλμα σύνδεσης με τον server κατά την αποθήκευση.");
    });
  };
};

export const fetchSubmittedVatDeclarations = (data, cb) => {
  return (dispatch) => {
    axios.post(`${apiURL2}/accounting/get-submitted-vat-declarations`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && (res.data.status === "200" || res.data.status === 200)) {
        const rawData = res.data.data;
        const resultList = rawData?.data || (Array.isArray(rawData) ? rawData : []);
        const total = rawData?.totalItems !== undefined ? rawData.totalItems : resultList.length;
        const perPage = rawData?.perPage || 20;

        const monthsMap = {
          1: "Ιανουάριος", 2: "Φεβρουάριος", 3: "Μάρτιος", 4: "Απρίλιος",
          5: "Μάιος", 6: "Ιούνιος", 7: "Ιούλιος", 8: "Αύγουστος",
          9: "Σεπτέμβριος", 10: "Οκτώβριος", 11: "Νοέμβριος", 12: "Δεκέμβριος"
        };
        const typesMap = {
          INITIAL: "Αρχική",
          AMENDING: "Τροποποιητική",
          WITH_RESERVATION: "Με Επιφύλαξη",
          EXTRAORDINARY: "Έκτακτη"
        };

        const formatted = resultList.map((decl) => {
          const fields = decl.fields || {};
          const val470 = Number(fields["470"] ?? fields["0470"]) || 0;
          const val480 = Number(fields["480"] ?? fields["0480"]) || 0;

          let balanceFormatted = "-";
          if (val480 > 0) {
            balanceFormatted = `-${val480}`;
          } else if (val470 > 0) {
            balanceFormatted = val470;
          } else {
            balanceFormatted = 0;
          }

          return {
            ...decl,
            monthName: monthsMap[decl.month] || decl.month || "-",
            declarationTypeName: typesMap[decl.declarationType] || decl.declarationType || "Αρχική",
            field311: Number(fields["311"] ?? fields["0311"]) || 0,
            field367: Number(fields["367"] ?? fields["0367"]) || 0,
            balanceFormatted: balanceFormatted
          };
        });

        dispatch(setSubmittedVatDeclarations(formatted));
        dispatch(setTotalItemsSVD(total));
        dispatch(setPerPageSVD(perPage));

        if (formatted.length === 0) toast.info("Δεν βρέθηκαν εγγραφές.");
        if (cb) cb();
      } else {
        dispatch(setSubmittedVatDeclarations([]));
        dispatch(setTotalItemsSVD(0));
        if (res.data?.status !== "404" && res.data?.status !== 404) {
          toast.error(res.data?.message || "Σφάλμα κατά την ανάκτηση δηλώσεων.");
        }
        if (cb) cb();
      }
    }).catch((err) => {
      console.error("Fetch submitted VAT error:", err);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      if (cb) cb();
    });
  };
};

export const postSubmittedF4Declarations = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoading === "function") setLoading(true);

    axios.post(`${apiURL2}/accounting/save-submitted-f4-vat-declarations`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (typeof setLoading === "function") setLoading(false);
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message || "Οι δηλώσεις Φ4 αποθηκεύτηκαν επιτυχώς!");
        dispatch(addToForceRefresh("Submitted F4 Declarations Search"));
        if (onSuccess) onSuccess(res.data.data);
      } else {
        toast.error(res.data.message || "Σφάλμα κατά την αποθήκευση δηλώσεων Φ4.");
      }
    }).catch((err) => {
      if (typeof setLoading === "function") setLoading(false);
      console.error("Save submitted F4 error:", err);
      toast.error("Σφάλμα επικοινωνίας με το ERP.");
    });
  };
};

export const fetchSubmittedF4Declarations = (data, cb) => {
  return (dispatch) => {
    axios.post(`${apiURL2}/accounting/get-submitted-f4-vat-declarations`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && (res.data.status === "200" || res.data.status === 200)) {
        const rawData = res.data.data;
        const resultList = rawData?.data || (Array.isArray(rawData) ? rawData : []);
        const total = rawData?.totalItems !== undefined ? rawData.totalItems : resultList.length;
        const perPage = rawData?.perPage || 20;

        const formatted = resultList.map((decl) => {
          return {
            ...decl,
            totalBc5: Number(decl.totalBc5 ?? decl.totals?.bc5) || 0,
            totalBc6: Number(decl.totalBc6 ?? decl.totals?.bc6) || 0,
            totalBc7: Number(decl.totalBc7 ?? decl.totals?.bc7) || 0,
            totalBc8: Number(decl.totalBc8 ?? decl.totals?.bc8) || 0
          };
        });

        dispatch(setSubmittedF4Declarations(formatted));
        dispatch(setTotalItemsSF4(total));
        dispatch(setPerPageSF4(perPage));

        if (formatted.length === 0) toast.info("Δεν βρέθηκαν εγγραφές.");
        if (cb) cb();
      } else {
        dispatch(setSubmittedF4Declarations([]));
        dispatch(setTotalItemsSF4(0));
        if (res.data?.status !== "404" && res.data?.status !== 404) {
          toast.error(res.data?.message || "Σφάλμα κατά την ανάκτηση δηλώσεων Φ4.");
        }
        if (cb) cb();
      }
    }).catch((err) => {
      console.error("Fetch submitted F4 error:", err);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      if (cb) cb();
    });
  };
};

export const postSubmittedF5Declarations = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoading === "function") setLoading(true);

    axios.post(`${apiURL2}/accounting/save-submitted-f5-vat-declarations`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (typeof setLoading === "function") setLoading(false);
      if (res.data && res.data.status === "200") {
        toast.success(res.data.message || "Οι δηλώσεις Φ5 αποθηκεύτηκαν επιτυχώς!");
        dispatch(addToForceRefresh("Submitted F5 Declarations Search"));
        if (onSuccess) onSuccess(res.data.data);
      } else {
        toast.error(res.data.message || "Σφάλμα κατά την αποθήκευση δηλώσεων Φ5.");
      }
    }).catch((err) => {
      if (typeof setLoading === "function") setLoading(false);
      console.error("Save submitted F5 error:", err);
      toast.error("Σφάλμα επικοινωνίας με το ERP.");
    });
  };
};

export const fetchSubmittedF5Declarations = (data, cb) => {
  return (dispatch) => {
    axios.post(`${apiURL2}/accounting/get-submitted-f5-vat-declarations`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && (res.data.status === "200" || res.data.status === 200)) {
        const rawData = res.data.data;
        const resultList = rawData?.data || (Array.isArray(rawData) ? rawData : []);
        const total = rawData?.totalItems !== undefined ? rawData.totalItems : resultList.length;
        const perPage = rawData?.perPage || 20;

        const monthsMap = {
          1: "Ιανουάριος", 2: "Φεβρουάριος", 3: "Μάρτιος", 4: "Απρίλιος",
          5: "Μάιος", 6: "Ιούνιος", 7: "Ιούλιος", 8: "Αύγουστος",
          9: "Σεπτέμβριος", 10: "Οκτώβριος", 11: "Νοέμβριος", 12: "Δεκέμβριος"
        };
        const typesMap = {
          INITIAL: "Αρχική",
          AMENDING: "Διορθωτική / Τροποποιητική"
        };

        const formatted = resultList.map((decl) => {
          return {
            ...decl,
            monthName: monthsMap[decl.month] || decl.monthName || (decl.month ? `${decl.month}ος` : "-"),
            declarationTypeName: typesMap[decl.declarationType] || decl.declarationTypeName || "Αρχική",
            totalBc5: Number(decl.totalBc5 ?? decl.totals?.bc5) || 0,
            totalBc6: Number(decl.totalBc6 ?? decl.totals?.bc6) || 0,
            totalBc7: Number(decl.totalBc7 ?? decl.totals?.bc7) || 0
          };
        });

        dispatch(setSubmittedF5Declarations(formatted));
        dispatch(setTotalItemsSF5(total));
        dispatch(setPerPageSF5(perPage));

        if (formatted.length === 0) toast.info("Δεν βρέθηκαν εγγραφές.");
        if (cb) cb();
      } else {
        dispatch(setSubmittedF5Declarations([]));
        dispatch(setTotalItemsSF5(0));
        if (res.data?.status !== "404" && res.data?.status !== 404) {
          toast.error(res.data?.message || "Σφάλμα κατά την ανάκτηση δηλώσεων Φ5.");
        }
        if (cb) cb();
      }
    }).catch((err) => {
      console.error("Fetch submitted F5 error:", err);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      if (cb) cb();
    });
  };
};

export const postUnregulatedDebts = (data, setLoading, onSuccess) => {
  return (dispatch) => {
    if (typeof setLoading === "function") setLoading(true);

    axios.post(`${apiURL2}/accounting/save-unregulated-debts`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (typeof setLoading === "function") setLoading(false);
      if (res.data && (res.data.status === "200" || res.data.status === 200)) {
        toast.success(res.data.message || "Οι οφειλές myAADE αποθηκεύτηκαν επιτυχώς!");
        dispatch(addToForceRefresh("Unregulated Debts Search"));
        if (onSuccess) onSuccess(res.data.data);
      } else {
        toast.error(res.data.message || "Σφάλμα κατά την αποθήκευση οφειλών στη βάση.");
      }
    }).catch((err) => {
      if (typeof setLoading === "function") setLoading(false);
      console.error("Save unregulated debts error:", err);
      toast.error("Σφάλμα επικοινωνίας με το ERP κατά την αποθήκευση των οφειλών.");
    });
  };
};

export const fetchUnregulatedDebts = (data, cb) => {
  return (dispatch) => {
    axios.post(`${apiURL2}/accounting/get-unregulated-debts`, data, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && (res.data.status === "200" || res.data.status === 200)) {
        const rawData = res.data.data;
        const resultList = rawData?.data || (Array.isArray(rawData) ? rawData : []);
        const total = rawData?.totalItems !== undefined ? rawData.totalItems : resultList.length;
        const perPage = rawData?.perPage || 20;
        const formatted = resultList.map((debt) => {
          const nonOverdue = Number(debt.nonOverdueAmount) || 0;
          const overdue = Number(debt.overdueAmount) || 0;
          const surcharges = Number(debt.surcharges) || 0;
          const totalAmount = Number(debt.totalAmount) || (nonOverdue + overdue + surcharges);

          return {
            ...debt,
            initialAmount: Number(debt.initialAmount) || 0,
            nonOverdueAmount: nonOverdue,
            overdueAmount: overdue,
            surcharges: surcharges,
            totalAmount: totalAmount,
            installmentsCount: debt.installments?.length || 0
          };
        });

        if (typeof setUnregulatedDebts === "function") {
          dispatch(setUnregulatedDebts(formatted));
          dispatch(setTotalItemsSUD(total));
          dispatch(setPerPageSUD(perPage));
        }

        if (rawData?.summary && typeof setDebtsSummaryData === "function") {
          dispatch(setDebtsSummaryData(rawData.summary));
        }

        if (formatted.length === 0) toast.info("Δεν βρέθηκαν οφειλές.");
        if (cb) cb(formatted);
      } else {
        if (typeof setUnregulatedDebts === "function") {
          dispatch(setUnregulatedDebts([]));
          dispatch(setTotalItemsSUD(0));
        }
        if (res.data?.status !== "404" && res.data?.status !== 404) {
          toast.error(res.data?.message || "Σφάλμα κατά την ανάκτηση των οφειλών.");
        }
        if (cb) cb([]);
      }
    }).catch((err) => {
      console.error("Fetch unregulated debts error:", err);
      toast.error("Σφάλμα κατά την αποστολή αιτήματος για τις οφειλές.");
      if (cb) cb([]);
    });
  };
};